<template>
  <div class="article--index">

    <div>
      <div class="tmp clearfix no-print">
        <button class="btn--3 btn--5" @click="reset(), setItem()">RESET</button>
        <button class="btn--3 btn--5" @click="all(), setItem()">ALL</button>
        <button class="btn--3 btn--4" @click="tmp1(), setItem()">一括お支払計算書</button>
        <button class="btn--3 btn--4" @click="tmp2(), setItem()">信販・自社お支払計算書</button>
        <button class="btn--3 btn--4" @click="tmp3(), setItem()">売掛金(一括)</button>
        <button class="btn--3 btn--4" @click="tmp4(), setItem()">売掛金(自社)</button>
        <button class="btn--3 btn--4" @click="tmp5(), setItem()">売掛金(信販)</button>
        <!-- <button class="btn--3 btn--4"><%#= link_to "CSV Download",api_v1_contracts_path(format: "csv") %></button>-->
      </div>

      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': id }" @click="greet('id'), setItem()">id</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': contract_type }" @click="greet('contract_type'), setItem()">契約種類</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': contract_date_start }" @click="greet('contract_date_start'), setitem()">契約日付</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': contract_date_end }" @click="greet('contract_date_end'), setItem()">〜契約日付</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': change_date }" @click="greet('change_date'), setItem()">内容変更日付</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': cancel_type }" @click="greet('cancel_type'), setItem()">解約種類</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': cancel_date }" @click="greet('cancel_date'), setItem()">解約日付</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': media }" @click="greet('media'), setItem()">媒体</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': f_name }" @click="greet('f_name'), setItem()">苗字</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': l_name }" @click="greet('l_name'), setItem()">名前</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': f_name_kana }" @click="greet('f_name_kana'), setItem()">苗字かな</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': l_name_kana }" @click="greet('l_name_kana'), setItem()">名前かな</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': tel }" @click="greet('tel'), setItem()">TEL</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': tel2 }" @click="greet('tel2'), setItem()">TEL2</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': address }" @click="greet('address'), setItem()">住所</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': address2 }" @click="greet('address2'), setItem()">住所2</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': payment_type }" @click="greet('payment_type'), setItem()">支払方法種別</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': text_type }" @click="greet('text_type'), setItem()">テキスト種類</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': amount }" @click="greet('amount'), setItem()">定価</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': discount }" @click="greet('discount'), setItem()">値引</button>
      <!-- <button class="btn&#45;&#45;3 no&#45;print" v&#45;bind:class="{ 'btn&#45;&#45;3&#45;&#45;active': split_commission }" @click="greet('split_commission'), setItem()">創拓社分割手数料</button> -->
      <!-- <button class="btn&#45;&#45;3 no&#45;print" v&#45;bind:class="{ 'btn&#45;&#45;3&#45;&#45;active': sales_commission }" @click="greet('sales_commission'), setItem()">販売手数料</button> -->
      <!-- <button class="btn&#45;&#45;3 no&#45;print" v&#45;bind:class="{ 'btn&#45;&#45;3&#45;&#45;active': sales_commission_head }" @click="greet('sales_commission_head'), setItem()">販売手数料(本社)</button> -->
      <!-- <button class="btn&#45;&#45;3 no&#45;print" v&#45;bind:class="{ 'btn&#45;&#45;3&#45;&#45;active': sales_commission_branch }" @click="greet('sales_commission_branch'), setItem()">販売手数料(支店)</button> -->
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': pure_amount }" @click="greet('pure_amount'), setItem()">販売価格</button>
      <!-- <button class="btn&#45;&#45;3 no&#45;print" v&#45;bind:class="{ 'btn&#45;&#45;3&#45;&#45;active': pure_amount_head }" @click="greet('pure_amount_head'), setItem()">販売価格(本社)</button> -->
      <!-- <button class="btn&#45;&#45;3 no&#45;print" v&#45;bind:class="{ 'btn&#45;&#45;3&#45;&#45;active': pure_amount_branch }" @click="greet('pure_amount_branch'), setItem()">販売価格(支店)</button> -->
      <!-- <button class="btn&#45;&#45;3 no&#45;print" v&#45;bind:class="{ 'btn&#45;&#45;3&#45;&#45;active': old_amount }" @click="greet('old_amount'), setItem()">旧販売価格</button> -->
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': division_commission }" @click="greet('division_commission'), setItem()">分割手数料</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': total_amount }" @click="greet('total_amount'), setItem()">お支払総額(手数料込)</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': agency_commission }" @click="greet('agency_commission'), setItem()">代行手数料</button>
      <!-- <button class="btn&#45;&#45;3 no&#45;print" v&#45;bind:class="{ 'btn&#45;&#45;3&#45;&#45;active': agency_commission_head }" @click="greet('agency_commission_head'), setItem()">代行手数料(本社)</button> -->
      <!-- <button class="btn&#45;&#45;3 no&#45;print" v&#45;bind:class="{ 'btn&#45;&#45;3&#45;&#45;active': agency_commission_branch }" @click="greet('agency_commission_branch'), setItem()">代行手数料(支店)</button> -->
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': agency_commission_own_installment }" @click="greet('agency_commission_own_installment'), setItem()">代行手数料(自社割賦)</button>
      <!-- <button class="btn&#45;&#45;3 no&#45;print" v&#45;bind:class="{ 'btn&#45;&#45;3&#45;&#45;active': purchase_amount }" @click="greet('purchase_amount'), setItem()">仕入れ額</button> -->
      <!-- <button class="btn&#45;&#45;3 no&#45;print" v&#45;bind:class="{ 'btn&#45;&#45;3&#45;&#45;active': purchase_amount_head }" @click="greet('purchase_amount_head'), setItem()">仕入れ額(本社)</button> -->
      <!-- <button class="btn&#45;&#45;3 no&#45;print" v&#45;bind:class="{ 'btn&#45;&#45;3&#45;&#45;active': purchase_amount_branch }" @click="greet('purchase_amount_branch'), setItem()">仕入れ額(支店)</button> -->
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': only_total_amount }" @click="greet('only_total_amount'), setItem()">のみ合計金額</button>
      <!-- <button class="btn&#45;&#45;3 no&#45;print" v&#45;bind:class="{ 'btn&#45;&#45;3&#45;&#45;active': only_total_amount_head }" @click="greet('only_total_amount_head'), setItem()">のみ合計金額(本社)</button> -->
      <!-- <button class="btn&#45;&#45;3 no&#45;print" v&#45;bind:class="{ 'btn&#45;&#45;3&#45;&#45;active': only_total_amount_branch }" @click="greet('only_total_amount_branch'), setItem()">のみ合計金額(支店)</button> -->
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': deposit_amount }" @click="greet('deposit_amount'), setItem()">入金額</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': deposit_amount_date }" @click="greet('deposit_amount_date'), setItem()">入金額入金日</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': down_payment }" @click="greet('down_payment'), setItem()">頭金</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': company_id }" @click="greet('company_id'), setItem()">会社</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': office_id }" @click="greet('office_id'), setItem()">営業所</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': person }" @click="greet('person'), setItem()">担当者</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': product_name }" @click="greet('product_name'), setItem()">商品名</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': payments_number }" @click="greet('payments_number'), setItem()">支払回数</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': text_payment_period_start }" @click="greet('text_payment_period_start'), setItem()">支払期間/開始(テキスト)</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': text_payment_period_end }" @click="greet('text_payment_period_end'), setItem()">支払期間/終了(テキスト)</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': service_period_start }" @click="greet('service_period_start'), setItem()">役務期間/開始</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': service_period_end }" @click="greet('service_period_end'), setItem()">役務期間/終了</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': administrative_expense }" @click="greet('administrative_expense'), setItem()">管理費</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': first_month_deposit }" @click="greet('first_month_deposit'), setItem()">初月管理費</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': first_month_deposit_method }" @click="greet('first_month_deposit_method'), setItem()">初月管理費支払方法</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': first_month_deposit_check }" @click="greet('first_month_deposit_check'), setItem()">初月管理費チェック</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': admission_fee }" @click="greet('admission_fee'), setItem()">入会金</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': admission_fee_method }" @click="greet('admission_fee_method'), setItem()">入会金支払方法</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': admission_fee_check }" @click="greet('admission_fee_check'), setItem()">入会金チェック</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': deposit }" @click="greet('deposit'), setItem()">保証金</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': deposit_method }" @click="greet('deposit_method'), setItem()">保証金支払方法</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': deposit_check }" @click="greet('deposit_check'), setItem()">保証金チェック</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': deposit_refund_date }" @click="greet('deposit_refund_date'), setItem()">保証金返金日</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': approval_date }" @click="greet('approval_date'), setItem()">承認日</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': approval_number }" @click="greet('approval_number'), setItem()">承認No.</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': delivery_date }" @click="greet('delivery_date'), setItem()">納品日</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': contract_collection_date }" @click="greet('contract_collection_date'), setItem()">契約書回収日</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': factor_collection_date }" @click="greet('factor_collection_date'), setItem()">ファクター回収日</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': penalty_amount_limit }" @click="greet('penalty_amount_limit'), setItem()">違約金入金期限</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': penalty_plans_amount }" @click="greet('penalty_plans_amount'), setItem()">違約金入金予定額</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': penalty_amount_date }" @click="greet('penalty_amount_date'), setItem()">違約金入金日</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': penalty_real_amount }" @click="greet('penalty_real_amount'), setItem()">違約金入金額</button>
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': grade }" @click="greet('grade'), setItem()">学年</button>
      <!-- <button class="btn&#45;&#45;3 no&#45;print" v&#45;bind:class="{ 'btn&#45;&#45;3&#45;&#45;active': point_s }" @click="greet('point_s'), setItem()">P(小学)</button> -->
      <!-- <button class="btn&#45;&#45;3 no&#45;print" v&#45;bind:class="{ 'btn&#45;&#45;3&#45;&#45;active': point_c }" @click="greet('point_c'), setItem()">P(中学)</button> -->
      <!-- <button class="btn&#45;&#45;3 no&#45;print" v&#45;bind:class="{ 'btn&#45;&#45;3&#45;&#45;active': point_k }" @click="greet('point_k'), setItem()">P(高校)</button> -->
      <!-- <button class="btn&#45;&#45;3 no&#45;print" v&#45;bind:class="{ 'btn&#45;&#45;3&#45;&#45;active': point_s_bulk }" @click="greet('point_s_bulk'), setItem()">一括P(小学)</button> -->
      <!-- <button class="btn&#45;&#45;3 no&#45;print" v&#45;bind:class="{ 'btn&#45;&#45;3&#45;&#45;active': point_c_bulk }" @click="greet('point_c_bulk'), setItem()">一括P(中学)</button> -->
      <!-- <button class="btn&#45;&#45;3 no&#45;print" v&#45;bind:class="{ 'btn&#45;&#45;3&#45;&#45;active': point_k_bulk }" @click="greet('point_k_bulk'), setItem()">一括P(高校)</button> -->
      <!-- <button class="btn&#45;&#45;3 no&#45;print" v&#45;bind:class="{ 'btn&#45;&#45;3&#45;&#45;active': point_total }" @click="greet('point_total'), setItem()">合計P</button> -->
      <button class="btn--3 no-print" v-bind:class="{ 'btn--3--active': note }" @click="greet('note'), setItem()">備考</button>

      <hr style="clear: both; height: 1px;">

      <div class="index-box" @scroll="offset">
        <table style="clear: both;">
          <tr>
            <th colspan="3" class="btn--new table__tr__td no-print"><a href="/contracts/new">新規登録</a></th>
            <template v-if="id"><th class="table__tr__th" @click="sortTable('id')">契約情報id</th></template>
            <template v-if="contract_type"><th class="table__tr__th" @click="sortTable('contract_type')">契約種類</th></template>
            <template v-if="contract_date_start"><th class="table__tr__th" @click="sortTable('contract_date')">契約日付</th></template>
            <template v-if="contract_date_end"><th class="table__tr__th" @click="sortTable('contract_date')">〜契約日付</th></template>
            <template v-if="change_date"><th class="table__tr__th" @click="sortTable('change_date')">内容変更日付</th></template>
            <template v-if="cancel_type"><th class="table__tr__th" @click="sortTable('cancel_type')">解約種類</th></template>
            <template v-if="cancel_date"><th class="table__tr__th" @click="sortTable('cancel_date')">解約日付</th></template>
            <template v-if="media"><th class="table__tr__th" @click="sortTable('media')">媒体</th></template>
            <template v-if="f_name"><th class="table__tr__th" @click="sortTable('f_name')">苗字</th></template>
            <template v-if="l_name"><th class="table__tr__th" @click="sortTable('l_name')">名前</th></template>
            <template v-if="f_name_kana"><th class="table__tr__th" @click="sortTable('f_name_kana')">苗字かな</th></template>
            <template v-if="l_name_kana"><th class="table__tr__th" @click="sortTable('l_name_kana')">名前かな</th></template>
            <template v-if="tel"><th class="table__tr__th" @click="sortTable('tel')">TEL</th></template>
            <template v-if="tel2"><th class="table__tr__th" @click="sortTable('tel2')">TEL2</th></template>
            <template v-if="address"><th class="table__tr__th" @click="sortTable('address')">住所</th></template>
            <template v-if="address2"><th class="table__tr__th" @click="sortTable('address2')">住所2</th></template>
            <template v-if="payment_type"><th class="table__tr__th" @click="sortTable('payment_type')">支払方法種別</th></template>
            <template v-if="text_type"><th class="table__tr__th" @click="sortTable('text_type')">テキスト種類</th></template>
            <template v-if="amount"><th class="table__tr__th" @click="sortTable('amount')">定価</th></template>
            <template v-if="discount"><th class="table__tr__th" @click="sortTable('discount')">値引</th></template>
            <!-- <template v&#45;if="split_commission"><th class="table__tr__th" @click="sortTable('split_commission')">創拓社分割手数料</th></template> -->
            <!-- <template v&#45;if="sales_commission"><th class="table__tr__th" @click="sortTable('sales_commission')">販売手数料</th></template> -->
            <!-- <template v&#45;if="sales_commission_head"><th class="table__tr__th" @click="sortTable('sales_commission_head')">販売手数料(本社)</th></template> -->
            <!-- <template v&#45;if="sales_commission_branch"><th class="table__tr__th" @click="sortTable('sales_commission_branch')">販売手数料(支店)</th></template> -->
            <template v-if="pure_amount"><th class="table__tr__th" @click="sortTable('pure_amount')">販売価格</th></template>
            <!-- <template v&#45;if="pure_amount_head"><th class="table__tr__th" @click="sortTable('pure_amount_head')">販売価格(本社)</th></template> -->
            <!-- <template v&#45;if="pure_amount_branch"><th class="table__tr__th" @click="sortTable('pure_amount_branch')">販売価格(支店)</th></template> -->
            <!-- <template v&#45;if="old_amount"><th class="table__tr__th" @click="sortTable('old_amount')">旧販売価格</th></template> -->
            <template v-if="division_commission"><th class="table__tr__th" @click="sortTable('division_commission')">分割手数料</th></template>
            <template v-if="total_amount"><th class="table__tr__th" @click="sortTable('total_amount')">お支払総額(手数料込)</th></template>
            <template v-if="agency_commission"><th class="table__tr__th" @click="sortTable('agency_commission')">代行手数料</th></template>
            <!-- <template v&#45;if="agency_commission_head"><th class="table__tr__th" @click="sortTable('agency_commission_head')">代行手数料(本社)</th></template> -->
            <!-- <template v&#45;if="agency_commission_branch"><th class="table__tr__th" @click="sortTable('agency_commission_branch')">代行手数料(支店)</th></template> -->
            <template v-if="agency_commission_own_installment"><th class="table__tr__th" @click="sortTable('agency_commission_own')">代行手数料(自社割賦)</th></template>
            <!-- <template v&#45;if="purchase_amount"><th class="table__tr__th" @click="sortTable('purchase_amount')">仕入れ額</th></template> -->
            <!-- <template v&#45;if="purchase_amount_head"><th class="table__tr__th" @click="sortTable('purchase_amount_head')">仕入れ額(本社)</th></template> -->
            <!-- <template v&#45;if="purchase_amount_branch"><th class="table__tr__th" @click="sortTable('purchase_amount_branch')">仕入れ額(支店)</th></template> -->
            <template v-if="only_total_amount"><th class="table__tr__th" @click="sortTable('only_total_amount')">のみ合計金額</th></template>
            <!-- <template v&#45;if="only_total_amount_head"><th class="table__tr__th" @click="sortTable('only_total_amount_head')">のみ合計金額(本社)</th></template> -->
            <!-- <template v&#45;if="only_total_amount_branch"><th class="table__tr__th" @click="sortTable('only_total_amount_branch')">のみ合計金額(支店)</th></template> -->
            <template v-if="deposit_amount"><th class="table__tr__th" @click="sortTable('deposit_amount')">入金額</th></template>
            <template v-if="deposit_amount_date"><th class="table__tr__th" @click="sortTable('deposit_amount_date')">入金額入金日</th></template>
            <template v-if="down_payment"><th class="table__tr__th" @click="sortTable('down_payment')">頭金</th></template>
            <template v-if="company_id"><th class="table__tr__th" @click="sortTable('company_id')">会社</th></template>
            <template v-if="office_id"><th class="table__tr__th" @click="sortTable('office_id')">営業所</th></template>
            <template v-if="person"><th class="table__tr__th" @click="sortTable('person')">担当者</th></template>
            <template v-if="product_name"><th class="table__tr__th" @click="sortTable('product_name')">商品名</th></template>
            <template v-if="payments_number"><th class="table__tr__th" @click="sortTable('payments_number')">支払回数</th></template>
            <template v-if="text_payment_period_start"><th class="table__tr__th" @click="sortTable('text_payment_period_start')">支払期間/開始(テキスト)</th></template>
            <template v-if="text_payment_period_end"><th class="table__tr__th" @click="sortTable('text_payment_period_end')">支払期間/終了(テキスト)</th></template>
            <template v-if="service_period_start"><th class="table__tr__th" @click="sortTable('service_period_start')">役務期間/開始</th></template>
            <template v-if="service_period_end"><th class="table__tr__th" @click="sortTable('service_period_end')">役務期間/終了</th></template>
            <template v-if="administrative_expense"><th class="table__tr__th" @click="sortTable('administrative_expense')">管理費</th></template>
            <template v-if="first_month_deposit"><th class="table__tr__th" @click="sortTable('first_month_deposit')">初月管理費</th></template>
            <template v-if="first_month_deposit_method"><th class="table__tr__th" @click="sortTable('first_month_deposit_method')">初月管理費支払方法</th></template>
            <template v-if="first_month_deposit_check"><th class="table__tr__th" @click="sortTable('first_month_deposit_check')">初月管理費チェック</th></template>
            <template v-if="admission_fee"><th class="table__tr__th" @click="sortTable('admission_fee')">入会金</th></template>
            <template v-if="admission_fee_method"><th class="table__tr__th" @click="sortTable('admission_fee_method')">入会金支払方法</th></template>
            <template v-if="admission_fee_check"><th class="table__tr__th" @click="sortTable('admission_fee_check')">入会金チェック</th></template>
            <template v-if="deposit"><th class="table__tr__th" @click="sortTable('deposit')">保証金</th></template>
            <template v-if="deposit_method"><th class="table__tr__th" @click="sortTable('deposit_method')">保証金支払方法</th></template>
            <template v-if="deposit_check"><th class="table__tr__th" @click="sortTable('deposit_check')">保証金チェック</th></template>
            <template v-if="deposit_refund_date"><th class="table__tr__th" @click="sortTable('deposit_refund_date')">保証金返金日</th></template>
            <template v-if="approval_date"><th class="table__tr__th" @click="sortTable('approval_date')">承認日</th></template>
            <template v-if="approval_number"><th class="table__tr__th" @click="sortTable('approval_number')">承認No.</th></template>
            <template v-if="delivery_date"><th class="table__tr__th" @click="sortTable('delivery_date')">納品日</th></template>
            <template v-if="contract_collection_date"><th class="table__tr__th" @click="sortTable('contract_collection_date')">契約書回収日</th></template>
            <template v-if="factor_collection_date"><th class="table__tr__th" @click="sortTable('factor_collection_date')">ファクター回収日</th></template>
            <template v-if="penalty_amount_limit"><th class="table__tr__th" @click="sortTable('penalty_amount_limit')">違約金入金期限</th></template>
            <template v-if="penalty_plans_amount"><th class="table__tr__th" @click="sortTable('penalty_plans_amount')">違約金入金予定額</th></template>
            <template v-if="penalty_amount_date"><th class="table__tr__th" @click="sortTable('penalty_amount_date')">違約金入金日</th></template>
            <template v-if="penalty_real_amount"><th class="table__tr__th" @click="sortTable('penalty_real_amount')">違約金入金額</th></template>
            <template v-if="grade"><th class="table__tr__th" @click="sortTable('grade')">学年</th></template>
            <!-- <template v&#45;if="point_s"><th class="table__tr__th" @click="sortTable('point_s')">P(小学)</th></template> -->
            <!-- <template v&#45;if="point_c"><th class="table__tr__th" @click="sortTable('point_c')">P(中学)</th></template> -->
            <!-- <template v&#45;if="point_k"><th class="table__tr__th" @click="sortTable('point_k')">P(高校)</th></template> -->
            <!-- <template v&#45;if="point_s_bulk"><th class="table__tr__th" @click="sortTable('point_s_bulk')">一括P(小学)</th></template> -->
            <!-- <template v&#45;if="point_c_bulk"><th class="table__tr__th" @click="sortTable('point_c_bulk')">一括P(中学)</th></template> -->
            <!-- <template v&#45;if="point_k_bulk"><th class="table__tr__th" @click="sortTable('point_k_bulk')">一括P(高校)</th></template> -->
            <!-- <template v&#45;if="point_total"><th class="table__tr__th" @click="sortTable('point_total')">合計P</th></template> -->
            <template v-if="note"><th class="table__tr__th" @click="sortTable('note')">備考</th></template>
          </tr>

          <tr class="search_tr no-print">
            <td colspan="3" class="table__tr__td">検索</td>
            <template v-if="id"><td class="table__tr__td"><div class="id"><input v-model="search.id" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="contract_type"><td class="table__tr__td"><div class="contract_type"><input v-model="search.contract_type" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="contract_date_start"><td class="table__tr__td"><div class="date"><input v-model="search.contract_date[0]" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="contract_date_end"><td class="table__tr__td"><div class="date"><input v-model="search.contract_date[1]" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="change_date"><td class="table__tr__td"><div class="date"><input v-model="search.change_date" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="cancel_type"><td class="table__tr__td"><div class="contract_type"><input v-model="search.cancel_type" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="cancel_date"><td class="table__tr__td"><div class="date"><input v-model="search.cancel_date" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="media"><td class="table__tr__td"><div><input v-model="search.media" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="f_name"><td class="table__tr__td"><div class="name"><input v-model="search.f_name" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="l_name"><td class="table__tr__td"><div class="name"><input v-model="search.l_name" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="f_name_kana"><td class="table__tr__td"><div class="name"><input v-model="search.f_name_kana" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="l_name_kana"><td class="table__tr__td"><div class="name"><input v-model="search.l_name_kana" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="tel"><td class="table__tr__td"><div class="tel"><input v-model="search.tel" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="tel2"><td class="table__tr__td"><div class="tel"><input v-model="search.tel2" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="address"><td class="table__tr__td"><div class="address"><input v-model="search.address" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="address2"><td class="table__tr__td"><div class="address"><input v-model="search.address2" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="payment_type"><td class="table__tr__td"><div class="payment_type"><input v-model="search.payment_type" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="text_type"><td class="table__tr__td"><div class="text_type"><input v-model="search.text_type" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="amount"><td class="table__tr__td"><div><input v-model="search.amount" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="discount"><td class="table__tr__td"><div><input v-model="search.discount" type="text" @keyup="searchTable()" ></div></td></template>
            <!-- <template v&#45;if="split_commission"><td class="table__tr__td"><div><input v&#45;model="search.split_commission" type="text" @keyup="searchTable()" ></div></td></template> -->
            <!-- <template v&#45;if="sales_commission"><td class="table__tr__td"><div><input v&#45;model="search.sales_commission" type="text" @keyup="searchTable()" ></div></td></template> -->
            <!-- <template v&#45;if="sales_commission_head"><td class="table__tr__td"><div><input v&#45;model="search.sales_commission_head" type="text" @keyup="searchTable()" ></div></td></template> -->
            <!-- <template v&#45;if="sales_commission_branch"><td class="table__tr__td"><div><input v&#45;model="search.sales_commission_branch" type="text" @keyup="searchTable()" ></div></td></template> -->
            <template v-if="pure_amount"><td class="table__tr__td"><div><input v-model="search.pure_amount" type="text" @keyup="searchTable()" ></div></td></template>
            <!-- <template v&#45;if="pure_amount_head"><td class="table__tr__td"><div><input v&#45;model="search.pure_amount_head" type="text" @keyup="searchTable()" ></div></td></template> -->
            <!-- <template v&#45;if="pure_amount_branch"><td class="table__tr__td"><div><input v&#45;model="search.pure_amount_branch" type="text" @keyup="searchTable()" ></div></td></template> -->
            <!-- <template v&#45;if="old_amount"><td class="table__tr__td"><div><input v-model="search.old_amount" type="text" @keyup="searchTable()" ></div></td></template> -->
            <template v-if="division_commission"><td class="table__tr__td"><div><input v-model="search.division_commission" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="total_amount"><td class="table__tr__td"><div><input v-model="search.total_amount" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="agency_commission"><td class="table__tr__td"><div><input v-model="search.agency_commission" type="text" @keyup="searchTable()" ></div></td></template>
            <!-- <template v&#45;if="agency_commission_head"><td class="table__tr__td"><div><input v&#45;model="search.agency_commission_head" type="text" @keyup="searchTable()" ></div></td></template> -->
            <!-- <template v&#45;if="agency_commission_branch"><td class="table__tr__td"><div><input v&#45;model="search.agency_commission_branch" type="text" @keyup="searchTable()" ></div></td></template> -->
            <template v-if="agency_commission_own_installment"><td class="table__tr__td"><div><input v-model="search.agency_commission_own_installment" type="text" @keyup="searchTable()" ></div></td></template>
            <!-- <template v&#45;if="purchase_amount"><td class="table__tr__td"><div><input v&#45;model="search.purchase_amount" type="text" @keyup="searchTable()" ></div></td></template> -->
            <!-- <template v&#45;if="purchase_amount_head"><td class="table__tr__td"><div><input v&#45;model="search.purchase_amount_head" type="text" @keyup="searchTable()" ></div></td></template> -->
            <!-- <template v&#45;if="purchase_amount_branch"><td class="table__tr__td"><div><input v&#45;model="search.purchase_amount_branch" type="text" @keyup="searchTable()" ></div></td></template> -->
            <template v-if="only_total_amount"><td class="table__tr__td"><div><input v-model="search.only_total_amount" type="text" @keyup="searchTable()" ></div></td></template>
            <!-- <template v&#45;if="only_total_amount_head"><td class="table__tr__td"><div><input v&#45;model="search.only_total_amount_head" type="text" @keyup="searchTable()" ></div></td></template> -->
            <!-- <template v&#45;if="only_total_amount_branch"><td class="table__tr__td"><div><input v&#45;model="search.only_total_amount_branch" type="text" @keyup="searchTable()" ></div></td></template> -->
            <template v-if="deposit_amount"><td class="table__tr__td"><div><input v-model="search.deposit_amount" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="deposit_amount_date"><td class="table__tr__td"><div class="date"><input v-model="search.deposit_amount_date" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="down_payment"><td class="table__tr__td"><div><input v-model="search.down_payment" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="company_id">
              <td class="table__tr__td">
                <div>
                  <select v-model="search.company_id" @change="searchTable()">
                    <!-- <option disabled value="">Please select one</option> -->
                    <option value="0"></option>
                    <option value="1">マスターマインズ</option>
                    <option value="2">エイト</option>
                    <option value="3">よんろく</option>
                    <option value="4">マスターピース</option>
                    <option value="5">マスタークライアント</option>
                  </select>
                </div>
              </td>
            </template>
            <template v-if="office_id">
              <td class="table__tr__td">
                <div>
                  <select v-model="search.office_id" @change="searchTable()">
                    <!-- <option disabled value="">Please select one</option> -->
                    <option value="0"></option>
                    <option value="1">仙台</option>
                    <option value="3">名古屋</option>
                    <option value="4">福岡</option>
                    <option value="6">大宮</option>
                    <option value="7">高松</option>
                    <option value="9">東京</option>
                    <option value="10">大阪</option>
                    <option value="2">札幌</option>
                    <option value="5">新宿</option>
                    <option value="8">高崎</option>
                  </select>
                </div>
              </td>
            </template>
            <template v-if="person"><td class="table__tr__td"><div><input v-model="search.person" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="product_name"><td class="table__tr__td"><div class="product"><input v-model="search.product_name" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="payments_number"><td class="table__tr__td"><div><input v-model="search.payments_number" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="text_payment_period_start"><td class="table__tr__td"><div class="date"><input v-model="search.text_payment_period_start" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="text_payment_period_end"><td class="table__tr__td"><div class="date"><input v-model="search.text_payment_period_end" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="service_period_start"><td class="table__tr__td"><div class="date"><input v-model="search.service_period_start" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="service_period_end"><td class="table__tr__td"><div class="date"><input v-model="search.service_period_end" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="administrative_expense"><td class="table__tr__td"><div><input v-model="search.administrative_expense" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="first_month_deposit"><td class="table__tr__td"><div><input v-model="search.first_month_deposit" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="first_month_deposit_method"><td class="table__tr__td"><div><input v-model="search.first_month_deposit_method" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="first_month_deposit_check"><td class="table__tr__td"><div><input v-model="search.first_month_deposit_check" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="admission_fee"><td class="table__tr__td"><div><input v-model="search.admission_fee" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="admission_fee_method"><td class="table__tr__td"><div><input v-model="search.admission_fee_method" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="admission_fee_check"><td class="table__tr__td"><div><input v-model="search.admission_fee_check" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="deposit"><td class="table__tr__td"><div><input v-model="search.deposit" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="deposit_method"><td class="table__tr__td"><div><input v-model="search.deposit_method" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="deposit_check"><td class="table__tr__td"><div><input v-model="search.deposit_check" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="deposit_refund_date"><td class="table__tr__td"><div class="date"><input v-model="search.deposit_refund_date" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="approval_date"><td class="table__tr__td"><div class="date"><input v-model="search.approval_date" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="approval_number"><td class="table__tr__td"><div class="number2"><input v-model="search.approval_number" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="delivery_date"><td class="table__tr__td"><div class="date"><input v-model="search.delivery_date" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="contract_collection_date"><td class="table__tr__td"><div class="date"><input v-model="search.contract_collection_date" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="factor_collection_date"><td class="table__tr__td"><div class="date"><input v-model="search.factor_collection_date" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="penalty_amount_limit"><td class="table__tr__td"><div class="date"><input v-model="search.penalty_amount_limit" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="penalty_plans_amount"><td class="table__tr__td"><div class="date"><input v-model="search.penalty_plans_amount" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="penalty_amount_date"><td class="table__tr__td"><div class="date"><input v-model="search.penalty_amount_date" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="penalty_real_amount"><td class="table__tr__td"><div class="date"><input v-model="search.penalty_real_amount" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="grade"><td class="table__tr__td"><div><input v-model="search.grade" type="text" @keyup="searchTable()" ></div></td></template>
            <!-- <template v&#45;if="point_s"><td class="table__tr__td"><div class="number"><input v&#45;model="search.point_s" type="text" @keyup="searchTable()" ></div></td></template> -->
            <!-- <template v&#45;if="point_c"><td class="table__tr__td"><div class="number"><input v&#45;model="search.point_c" type="text" @keyup="searchTable()" ></div></td></template> -->
            <!-- <template v&#45;if="point_k"><td class="table__tr__td"><div class="number"><input v&#45;model="search.point_k" type="text" @keyup="searchTable()" ></div></td></template> -->
            <!-- <template v&#45;if="point_s_bulk"><td class="table__tr__td"><div class="number"><input v&#45;model="search.point_s_bulk" type="text" @keyup="searchTable()" ></div></td></template> -->
            <!-- <template v&#45;if="point_c_bulk"><td class="table__tr__td"><div class="number"><input v&#45;model="search.point_c_bulk" type="text" @keyup="searchTable()" ></div></td></template> -->
            <!-- <template v&#45;if="point_k_bulk"><td class="table__tr__td"><div class="number"><input v&#45;model="search.point_k_bulk" type="text" @keyup="searchTable()" ></div></td></template> -->
            <!-- <template v&#45;if="point_total"><td class="table__tr__td"><div class="number"><input v&#45;model="search.point_total" type="text" @keyup="searchTable()" ></div></td></template> -->
            <template v-if="note"><td class="table__tr__td"><div class="note"><input v-model="search.note" type="text" @keyup="searchTable()" ></div></td></template>
          </tr>

          <tr class="search_tr no-print">
            <td colspan="3" class="table__tr__td">除外検索</td>
            <template v-if="id"><td class="table__tr__td"><div class="id"><input v-model="search.not_id" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="contract_type"><td class="table__tr__td"><div class="contract_type"><input v-model="search.not_contract_type" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="contract_date_start"><td class="table__tr__td"><div class="date"><input v-model="search.not_contract_date[0]" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="contract_date_end"><td class="table__tr__td"><div class="date"><input v-model="search.not_contract_date[1]" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="change_date"><td class="table__tr__td"><div class="date"><input v-model="search.not_change_date" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="cancel_type"><td class="table__tr__td"><div class="contract_type"><input v-model="search.not_cancel_type" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="cancel_date"><td class="table__tr__td"><div class="date"><input v-model="search.not_cancel_date" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="media"><td class="table__tr__td"><div><input v-model="search.not_media" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="f_name"><td class="table__tr__td"><div class="name"><input v-model="search.not_f_name" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="l_name"><td class="table__tr__td"><div class="name"><input v-model="search.not_l_name" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="f_name_kana"><td class="table__tr__td"><div class="name"><input v-model="search.not_f_name_kana" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="l_name_kana"><td class="table__tr__td"><div class="name"><input v-model="search.not_l_name_kana" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="tel"><td class="table__tr__td"><div class="tel"><input v-model="search.not_tel" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="tel2"><td class="table__tr__td"><div class="tel"><input v-model="search.not_tel2" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="address"><td class="table__tr__td"><div class="address"><input v-model="search.not_address" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="address2"><td class="table__tr__td"><div class="address"><input v-model="search.not_address2" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="payment_type"><td class="table__tr__td"><div class="payment_type"><input v-model="search.not_payment_type" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="text_type"><td class="table__tr__td"><div class="text_type"><input v-model="search.not_text_type" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="amount"><td class="table__tr__td"><div><input v-model="search.not_amount" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="discount"><td class="table__tr__td"><div><input v-model="search.not_discount" type="text" @keyup="searchTable()" ></div></td></template>
            <!-- <template v&#45;if="split_commission"><td class="table__tr__td"><div><input v&#45;model="search.not_split_commission" type="text" @keyup="searchTable()" ></div></td></template> -->
            <!-- <template v&#45;if="sales_commission"><td class="table__tr__td"><div><input v&#45;model="search.not_sales_commission" type="text" @keyup="searchTable()" ></div></td></template> -->
            <!-- <template v&#45;if="sales_commission_head"><td class="table__tr__td"><div><input v&#45;model="search.not_sales_commission_head" type="text" @keyup="searchTable()" ></div></td></template> -->
            <!-- <template v&#45;if="sales_commission_branch"><td class="table__tr__td"><div><input v&#45;model="search.not_sales_commission_branch" type="text" @keyup="searchTable()" ></div></td></template> -->
            <template v-if="pure_amount"><td class="table__tr__td"><div><input v-model="search.not_pure_amount" type="text" @keyup="searchTable()" ></div></td></template>
            <!-- <template v&#45;if="pure_amount_head"><td class="table__tr__td"><div><input v&#45;model="search.not_pure_amount_head" type="text" @keyup="searchTable()" ></div></td></template> -->
            <!-- <template v&#45;if="pure_amount_branch"><td class="table__tr__td"><div><input v&#45;model="search.not_pure_amount_branch" type="text" @keyup="searchTable()" ></div></td></template> -->
            <!-- <template v&#45;if="old_amount"><td class="table__tr__td"><div><input v-model="search.not_old_amount" type="text" @keyup="searchTable()" ></div></td></template> -->
            <template v-if="division_commission"><td class="table__tr__td"><div><input v-model="search.not_division_commission" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="total_amount"><td class="table__tr__td"><div><input v-model="search.not_total_amount" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="agency_commission"><td class="table__tr__td"><div><input v-model="search.not_agency_commission" type="text" @keyup="searchTable()" ></div></td></template>
            <!-- <template v&#45;if="agency_commission_head"><td class="table__tr__td"><div><input v&#45;model="search.not_agency_commission_head" type="text" @keyup="searchTable()" ></div></td></template> -->
            <!-- <template v&#45;if="agency_commission_branch"><td class="table__tr__td"><div><input v&#45;model="search.not_agency_commission_branch" type="text" @keyup="searchTable()" ></div></td></template> -->
            <template v-if="agency_commission_own_installment"><td class="table__tr__td"><div><input v-model="search.not_agency_commission_own_installment" type="text" @keyup="searchTable()" ></div></td></template>
            <!-- <template v&#45;if="purchase_amount"><td class="table__tr__td"><div><input v&#45;model="search.not_purchase_amount" type="text" @keyup="searchTable()" ></div></td></template> -->
            <!-- <template v&#45;if="purchase_amount_head"><td class="table__tr__td"><div><input v&#45;model="search.not_purchase_amount_head" type="text" @keyup="searchTable()" ></div></td></template> -->
            <!-- <template v&#45;if="purchase_amount_branch"><td class="table__tr__td"><div><input v&#45;model="search.not_purchase_amount_branch" type="text" @keyup="searchTable()" ></div></td></template> -->
            <template v-if="only_total_amount"><td class="table__tr__td"><div><input v-model="search.not_only_total_amount" type="text" @keyup="searchTable()" ></div></td></template>
            <!-- <template v&#45;if="only_total_amount_head"><td class="table__tr__td"><div><input v&#45;model="search.not_only_total_amount_head" type="text" @keyup="searchTable()" ></div></td></template> -->
            <!-- <template v&#45;if="only_total_amount_branch"><td class="table__tr__td"><div><input v&#45;model="search.not_only_total_amount_branch" type="text" @keyup="searchTable()" ></div></td></template> -->
            <template v-if="deposit_amount"><td class="table__tr__td"><div><input v-model="search.not_deposit_amount" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="deposit_amount_date"><td class="table__tr__td"><div class="date"><input v-model="search.not_deposit_amount_date" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="down_payment"><td class="table__tr__td"><div><input v-model="search.not_down_payment" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="company_id">
              <td class="table__tr__td">
                <div>
                  <select v-model="search.not_company_id" @change="searchTable()">
                    <!-- <option disabled value="">Please select one</option> -->
                    <option value="0"></option>
                    <option value="1">マスターマインズ</option>
                    <option value="2">エイト</option>
                    <option value="3">よんろく</option>
                    <option value="4">マスターピース</option>
                    <option value="5">マスタークライアント</option>
                  </select>
                </div>
              </td>
            </template>
            <template v-if="office_id">
              <td class="table__tr__td">
                <div>
                  <select v-model="search.not_office_id" @change="searchTable()">
                    <!-- <option disabled value="">Please select one</option> -->
                    <option value="0"></option>
                    <option value="1">仙台</option>
                    <option value="3">名古屋</option>
                    <option value="4">福岡</option>
                    <option value="6">大宮</option>
                    <option value="7">高松</option>
                    <option value="9">東京</option>
                    <option value="10">大阪</option>
                    <option value="2">札幌</option>
                    <option value="5">新宿</option>
                    <option value="8">高崎</option>
                  </select>
                </div>
              </td>
            </template>
            <template v-if="person"><td class="table__tr__td"><div><input v-model="search.not_person" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="product_name"><td class="table__tr__td"><div class="product"><input v-model="search.not_product_name" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="payments_number"><td class="table__tr__td"><div><input v-model="search.not_payments_number" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="text_payment_period_start"><td class="table__tr__td"><div class="date"><input v-model="search.not_text_payment_period_start" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="text_payment_period_end"><td class="table__tr__td"><div class="date"><input v-model="search.not_text_payment_period_end" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="service_period_start"><td class="table__tr__td"><div class="date"><input v-model="search.not_service_period_start" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="service_period_end"><td class="table__tr__td"><div class="date"><input v-model="search.not_service_period_end" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="administrative_expense"><td class="table__tr__td"><div><input v-model="search.not_administrative_expense" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="first_month_deposit"><td class="table__tr__td"><div><input v-model="search.not_first_month_deposit" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="first_month_deposit_method"><td class="table__tr__td"><div><input v-model="search.not_first_month_deposit_method" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="first_month_deposit_check"><td class="table__tr__td"><div><input v-model="search.not_first_month_deposit_check" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="admission_fee"><td class="table__tr__td"><div><input v-model="search.not_admission_fee" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="admission_fee_method"><td class="table__tr__td"><div><input v-model="search.not_admission_fee_method" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="admission_fee_check"><td class="table__tr__td"><div><input v-model="search.not_admission_fee_check" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="deposit"><td class="table__tr__td"><div><input v-model="search.not_deposit" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="deposit_method"><td class="table__tr__td"><div><input v-model="search.not_deposit_method" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="deposit_check"><td class="table__tr__td"><div><input v-model="search.not_deposit_check" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="deposit_refund_date"><td class="table__tr__td"><div class="date"><input v-model="search.not_deposit_refund_date" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="approval_date"><td class="table__tr__td"><div class="date"><input v-model="search.not_approval_date" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="approval_number"><td class="table__tr__td"><div class="number2"><input v-model="search.not_approval_number" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="delivery_date"><td class="table__tr__td"><div class="date"><input v-model="search.not_delivery_date" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="contract_collection_date"><td class="table__tr__td"><div class="date"><input v-model="search.not_contract_collection_date" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="factor_collection_date"><td class="table__tr__td"><div class="date"><input v-model="search.not_factor_collection_date" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="penalty_amount_limit"><td class="table__tr__td"><div class="date"><input v-model="search.not_penalty_amount_limit" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="penalty_plans_amount"><td class="table__tr__td"><div class="date"><input v-model="search.not_penalty_plans_amount" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="penalty_amount_date"><td class="table__tr__td"><div class="date"><input v-model="search.not_penalty_amount_date" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="penalty_real_amount"><td class="table__tr__td"><div class="date"><input v-model="search.not_penalty_real_amount" type="text" @keyup="searchTable()" ></div></td></template>
            <template v-if="grade"><td class="table__tr__td"><div><input v-model="search.not_grade" type="text" @keyup="searchTable()" ></div></td></template>
            <!-- <template v&#45;if="point_s"><td class="table__tr__td"><div class="number"><input v&#45;model="search.not_point_s" type="text" @keyup="searchTable()" ></div></td></template> -->
            <!-- <template v&#45;if="point_c"><td class="table__tr__td"><div class="number"><input v&#45;model="search.not_point_c" type="text" @keyup="searchTable()" ></div></td></template> -->
            <!-- <template v&#45;if="point_k"><td class="table__tr__td"><div class="number"><input v&#45;model="search.not_point_k" type="text" @keyup="searchTable()" ></div></td></template> -->
            <!-- <template v&#45;if="point_s_bulk"><td class="table__tr__td"><div class="number"><input v&#45;model="search.not_point_s_bulk" type="text" @keyup="searchTable()" ></div></td></template> -->
            <!-- <template v&#45;if="point_c_bulk"><td class="table__tr__td"><div class="number"><input v&#45;model="search.not_point_c_bulk" type="text" @keyup="searchTable()" ></div></td></template> -->
            <!-- <template v&#45;if="point_k_bulk"><td class="table__tr__td"><div class="number"><input v&#45;model="search.not_point_k_bulk" type="text" @keyup="searchTable()" ></div></td></template> -->
            <!-- <template v&#45;if="point_total"><td class="table__tr__td"><div class="number"><input v&#45;model="search.not_point_total" type="text" @keyup="searchTable()" ></div></td></template> -->
            <template v-if="note"><td class="table__tr__td"><div class="note"><input v-model="search.not_note" type="text" @keyup="searchTable()" ></div></td></template>
          </tr>

          <tr class="total_tr no-print">
            <td colspan="3" class="table__tr__td">集計</td>
            <template v-if="id"><td class="table__tr__td"><div class="id">{{max}}</div></td></template>
            <template v-if="contract_type"><td class="table__tr__td eee"><div class="contract_type"></div></td></template>
            <template v-if="contract_date_start"><td class="table__tr__td eee"><div class="date"></div></td></template>
            <template v-if="contract_date_end"><td class="table__tr__td eee"><div class="date"></div></td></template>
            <template v-if="change_date"><td class="table__tr__td eee"><div class="date"></div></td></template>
            <template v-if="cancel_type"><td class="table__tr__td eee"><div class="contract_type"></div></td></template>
            <template v-if="cancel_date"><td class="table__tr__td eee"><div class="date"></div></td></template>
            <template v-if="media"><td class="table__tr__td eee"><div></div></td></template>
            <template v-if="f_name"><td class="table__tr__td eee"><div class="name"></div></td></template>
            <template v-if="l_name"><td class="table__tr__td eee"><div class="name"></div></td></template>
            <template v-if="f_name_kana"><td class="table__tr__td eee"><div class="name"></div></td></template>
            <template v-if="l_name_kana"><td class="table__tr__td eee"><div class="name"></div></td></template>
            <template v-if="tel"><td class="table__tr__td eee"><div class="tel"></div></td></template>
            <template v-if="tel2"><td class="table__tr__td eee"><div class="tel"></div></td></template>
            <template v-if="address"><td class="table__tr__td eee"><div class="address"></div></td></template>
            <template v-if="address2"><td class="table__tr__td eee"><div class="address"></div></td></template>
            <template v-if="payment_type"><td class="table__tr__td eee"><div class="payment_type"></div></td></template>
            <template v-if="text_type"><td class="table__tr__td eee"><div class="text_type"></div></td></template>
            <template v-if="amount"><td class="table__tr__td"><div>{{sum.amount.toLocaleString()}}</div></td></template>
            <template v-if="discount"><td class="table__tr__td"><div>{{sum.discount.toLocaleString()}}</div></td></template>
            <!-- <template v&#45;if="split_commission"><td class="table__tr__td"><div>{{sum.split_commission.toLocaleString()}}</div></td></template> -->
            <!-- <template v&#45;if="sales_commission"><td class="table__tr__td"><div>{{sum.sales_commission.toLocaleString()}}</div></td></template> -->
            <!-- <template v&#45;if="sales_commission_head"><td class="table__tr__td"><div>{{sum.sales_commission_head.toLocaleString()}}</div></td></template> -->
            <!-- <template v&#45;if="sales_commission_branch"><td class="table__tr__td"><div>{{sum.sales_commission_branch.toLocaleString()}}</div></td></template> -->
            <template v-if="pure_amount"><td class="table__tr__td"><div>{{sum.pure_amount.toLocaleString()}}</div></td></template>
            <!-- <template v&#45;if="pure_amount_head"><td class="table__tr__td"><div>{{sum.pure_amount_head.toLocaleString()}}</div></td></template> -->
            <!-- <template v&#45;if="pure_amount_branch"><td class="table__tr__td"><div>{{sum.pure_amount_branch.toLocaleString()}}</div></td></template> -->
            <!-- <template v&#45;if="old_amount"><td class="table__tr__td"><div>{{sum.old_amount}}</div></td></template> -->
            <template v-if="division_commission"><td class="table__tr__td"><div>{{sum.division_commission.toLocaleString()}}</div></td></template>
            <template v-if="total_amount"><td class="table__tr__td"><div>{{sum.total_amount.toLocaleString()}}</div></td></template>
            <template v-if="agency_commission"><td class="table__tr__td"><div>{{sum.agency_commission.toLocaleString()}}</div></td></template>
            <!-- <template v&#45;if="agency_commission_head"><td class="table__tr__td"><div>{{sum.agency_commission_head.toLocaleString()}}</div></td></template> -->
            <!-- <template v&#45;if="agency_commission_branch"><td class="table__tr__td"><div>{{sum.agency_commission_branch.toLocaleString()}}</div></td></template> -->
            <template v-if="agency_commission_own_installment"><td class="table__tr__td"><div>{{sum.agency_commission_own_installment.toLocaleString()}}</div></td></template>
            <!-- <template v&#45;if="purchase_amount"><td class="table__tr__td"><div>{{sum.purchase_amount.toLocaleString()}}</div></td></template> -->
            <!-- <template v&#45;if="purchase_amount_head"><td class="table__tr__td"><div>{{sum.purchase_amount_head.toLocaleString()}}</div></td></template> -->
            <!-- <template v&#45;if="purchase_amount_branch"><td class="table__tr__td"><div>{{sum.purchase_amount_branch.toLocaleString()}}</div></td></template> -->
            <template v-if="only_total_amount"><td class="table__tr__td"><div>{{sum.only_total_amount.toLocaleString()}}</div></td></template>
            <!-- <template v&#45;if="only_total_amount_head"><td class="table__tr__td"><div>{{sum.only_total_amount_head.toLocaleString()}}</div></td></template> -->
            <!-- <template v&#45;if="only_total_amount_branch"><td class="table__tr__td"><div>{{sum.only_total_amount_branch.toLocaleString()}}</div></td></template> -->
            <template v-if="deposit_amount"><td class="table__tr__td"><div>{{sum.deposit_amount.toLocaleString()}}</div></td></template>
            <template v-if="deposit_amount_date"><td class="table__tr__td eee"><div class="date"></div></td></template>
            <template v-if="down_payment"><td class="table__tr__td"><div>{{sum.down_payment.toLocaleString()}}</div></td></template>
            <template v-if="company_id"><td class="table__tr__td eee"><div class="office"></div></td></template>
            <template v-if="office_id"><td class="table__tr__td eee"><div class="office"></div></td></template>
            <template v-if="person"><td class="table__tr__td eee"><div></div></td></template>
            <template v-if="product_name"><td class="table__tr__td eee"><div class="product"></div></td></template>
            <template v-if="payments_number"><td class="table__tr__td eee"><div></div></td></template>
            <template v-if="text_payment_period_start"><td class="table__tr__td eee"><div class="date"></div></td></template>
            <template v-if="text_payment_period_end"><td class="table__tr__td eee"><div class="date"></div></td></template>
            <template v-if="service_period_start"><td class="table__tr__td eee"><div class="date"></div></td></template>
            <template v-if="service_period_end"><td class="table__tr__td eee"><div class="date"></div></td></template>
            <template v-if="administrative_expense"><td class="table__tr__td"><div>{{sum.administrative_expense.toLocaleString()}}</div></td></template>
            <template v-if="first_month_deposit"><td class="table__tr__td"><div>{{sum.first_month_deposit.toLocaleString()}}</div></td></template>
            <template v-if="first_month_deposit_method"><td class="table__tr__td eee"><div></div></td></template>
            <template v-if="first_month_deposit_check"><td class="table__tr__td eee"><div></div></td></template>
            <template v-if="admission_fee"><td class="table__tr__td"><div>{{sum.admission_fee.toLocaleString()}}</div></td></template>
            <template v-if="admission_fee_method"><td class="table__tr__td eee"><div></div></td></template>
            <template v-if="admission_fee_check"><td class="table__tr__td eee"><div></div></td></template>
            <template v-if="deposit"><td class="table__tr__td"><div>{{sum.deposit.toLocaleString()}}</div></td></template>
            <template v-if="deposit_method"><td class="table__tr__td eee"><div></div></td></template>
            <template v-if="deposit_check"><td class="table__tr__td eee"><div></div></td></template>
            <template v-if="deposit_refund_date"><td class="table__tr__td eee"><div class="date"></div></td></template>
            <template v-if="approval_date"><td class="table__tr__td eee"><div class="date"></div></td></template>
            <template v-if="approval_number"><td class="table__tr__td eee"><div class="number2"></div></td></template>
            <template v-if="delivery_date"><td class="table__tr__td eee"><div class="date"></div></td></template>
            <template v-if="contract_collection_date"><td class="table__tr__td eee"><div class="date"></div></td></template>
            <template v-if="factor_collection_date"><td class="table__tr__td eee"><div class="date"></div></td></template>
            <template v-if="penalty_amount_limit"><td class="table__tr__td eee"><div class="date"></div></td></template>
            <template v-if="penalty_plans_amount"><td class="table__tr__td eee"><div class="date"></div></td></template>
            <template v-if="penalty_amount_date"><td class="table__tr__td eee"><div class="date"></div></td></template>
            <template v-if="penalty_real_amount"><td class="table__tr__td eee"><div class="date"></div></td></template>
            <template v-if="grade"><td class="table__tr__td eee"><div></div></td></template>
            <!-- <template v&#45;if="point_s"><td class="table__tr__td"><div class="number">{{sum.point_s}}</div></td></template> -->
            <!-- <template v&#45;if="point_c"><td class="table__tr__td"><div class="number">{{sum.point_c}}</div></td></template> -->
            <!-- <template v&#45;if="point_k"><td class="table__tr__td"><div class="number">{{sum.point_k}}</div></td></template> -->
            <!-- <template v&#45;if="point_s_bulk"><td class="table__tr__td"><div class="number">{{sum.point_s_bulk}}</div></td></template> -->
            <!-- <template v&#45;if="point_c_bulk"><td class="table__tr__td"><div class="number">{{sum.point_c_bulk}}</div></td></template> -->
            <!-- <template v&#45;if="point_k_bulk"><td class="table__tr__td"><div class="number">{{sum.point_k_bulk}}</div></td></template> -->
            <!-- <template v&#45;if="point_total"><td class="table__tr__td"><div class="number">{{sum.point_total}}</div></td></template> -->
            <template v-if="note"><td class="table__tr__td eee"><div class="note"></div></td></template>
          </tr>

          <tr v-for="item in contracts" track-by="id" :key="item.id" class="table__tr">
            <td class="btn--1 no-print"><a v-bind:href="'/contracts/'+item.id" target="_blank">詳細</a></td>
            <td class="btn--1 no-print"><a v-bind:href="'/contracts/'+item.id+'/edit'" target="_blank">編集</a></td>
            <td class="btn--1 no-print"><a data-confirm="本当に削除しますか？" rel="nofollow" data-method="delete" v-bind:href="'/contracts/'+item.id">削除</a></td>
            <template v-if="id"><td class="table__tr__td"><div class="id">{{item.id}}</div></td></template>
            <template v-if="contract_type"><td class="table__tr__td"><div class="contract_type">{{item.contract_type}}</div></td></template>
            <template v-if="contract_date_start"><td class="table__tr__td"><div class="date">{{item.contract_date}}</div></td></template>
            <template v-if="contract_date_end"><td class="table__tr__td eee"><div class="date"></div></td></template>
            <template v-if="change_date"><td class="table__tr__td"><div class="date">{{item.change_date}}</div></td></template>
            <template v-if="cancel_type"><td class="table__tr__td"><div class="contract_type">{{item.cancel_type}}</div></td></template>
            <template v-if="cancel_date"><td class="table__tr__td"><div class="date">{{item.cancel_date}}</div></td></template>
            <template v-if="media"><td class="table__tr__td"><div>{{item.media}}</div></td></template>
            <template v-if="f_name"><td class="table__tr__td"><div class="name">{{item.f_name}}</div></td></template>
            <template v-if="l_name"><td class="table__tr__td"><div class="name">{{item.l_name}}</div></td></template>
            <template v-if="f_name_kana"><td class="table__tr__td"><div class="name">{{item.f_name_kana}}</div></td></template>
            <template v-if="l_name_kana"><td class="table__tr__td"><div class="name">{{item.l_name_kana}}</div></td></template>
            <template v-if="tel"><td class="table__tr__td"><div class="tel">{{item.tel}}</div></td></template>
            <template v-if="tel2"><td class="table__tr__td"><div class="tel">{{item.tel2}}</div></td></template>
            <template v-if="address"><td class="table__tr__td"><div class="address">{{item.address}}</div></td></template>
            <template v-if="address2"><td class="table__tr__td"><div class="address">{{item.address2}}</div></td></template>
            <template v-if="payment_type"><td class="table__tr__td"><div class="payment_type">{{item.payment_type}}</div></td></template>
            <template v-if="text_type"><td class="table__tr__td"><div class="text_type">{{item.text_type}}</div></td></template>
            <template v-if="amount"><td class="table__tr__td"><div>{{item.amount.toLocaleString()}}</div></td></template>
            <template v-if="discount"><td class="table__tr__td"><div>{{item.discount.toLocaleString()}}</div></td></template>
            <!-- <template v&#45;if="split_commission"><td class="table__tr__td"><div>{{item.split_commission.toLocaleString()}}</div></td></template> -->
            <!-- <template v&#45;if="sales_commission"><td class="table__tr__td"><div>{{item.sales_commission.toLocaleString()}}</div></td></template> -->
            <!-- <template v&#45;if="sales_commission_head"><td class="table__tr__td"><div>{{item.sales_commission_head.toLocaleString()}}</div></td></template> -->
            <!-- <template v&#45;if="sales_commission_branch"><td class="table__tr__td"><div>{{item.sales_commission_branch.toLocaleString()}}</div></td></template> -->
            <template v-if="pure_amount"><td class="table__tr__td"><div>{{item.pure_amount.toLocaleString()}}</div></td></template>
            <!-- <template v&#45;if="pure_amount_head"><td class="table__tr__td"><div>{{item.pure_amount_head.toLocaleString()}}</div></td></template> -->
            <!-- <template v&#45;if="pure_amount_branch"><td class="table__tr__td"><div>{{item.pure_amount_branch.toLocaleString()}}</div></td></template> -->
            <!-- <template v&#45;if="old_amount"><td class="table__tr__td"><div>{{item.old_amount}}</div></td></template> -->
            <template v-if="division_commission"><td class="table__tr__td"><div>{{item.division_commission.toLocaleString()}}</div></td></template>
            <template v-if="total_amount"><td class="table__tr__td"><div>{{item.total_amount.toLocaleString()}}</div></td></template>
            <template v-if="agency_commission"><td class="table__tr__td"><div>{{item.agency_commission.toLocaleString()}}</div></td></template>
            <!-- <template v&#45;if="agency_commission_head"><td class="table__tr__td"><div>{{item.agency_commission_head.toLocaleString()}}</div></td></template> -->
            <!-- <template v&#45;if="agency_commission_branch"><td class="table__tr__td"><div>{{item.agency_commission_branch.toLocaleString()}}</div></td></template> -->
            <template v-if="agency_commission_own_installment"><td class="table__tr__td"><div>{{item.agency_commission_own_installment.toLocaleString()}}</div></td></template>
            <!-- <template v&#45;if="purchase_amount"><td class="table__tr__td"><div>{{item.purchase_amount.toLocaleString()}}</div></td></template> -->
            <!-- <template v&#45;if="purchase_amount_head"><td class="table__tr__td"><div>{{item.purchase_amount_head.toLocaleString()}}</div></td></template> -->
            <!-- <template v&#45;if="purchase_amount_branch"><td class="table__tr__td"><div>{{item.purchase_amount_branch.toLocaleString()}}</div></td></template> -->
            <template v-if="only_total_amount"><td class="table__tr__td"><div>{{item.only_total_amount.toLocaleString()}}</div></td></template>
            <!-- <template v&#45;if="only_total_amount_head"><td class="table__tr__td"><div>{{item.only_total_amount_head.toLocaleString()}}</div></td></template> -->
            <!-- <template v&#45;if="only_total_amount_branch"><td class="table__tr__td"><div>{{item.only_total_amount_branch.toLocaleString()}}</div></td></template> -->
            <template v-if="deposit_amount"><td class="table__tr__td"><div>{{item.deposit_amount.toLocaleString()}}</div></td></template>
            <template v-if="deposit_amount_date"><td class="table__tr__td"><div class="date">{{item.deposit_amount_date}}</div></td></template>
            <template v-if="down_payment"><td class="table__tr__td"><div>{{item.down_payment.toLocaleString()}}</div></td></template>
            <template v-if="company_id">
              <td class="table__tr__td">
                <div class="office">
                  <template v-if="item.company_id === 0"></template>
                  <template v-if="item.company_id === 1">マスターマインズ</template>
                  <template v-if="item.company_id === 2">エイト</template>
                  <template v-if="item.company_id === 3">よんろく</template>
                  <template v-if="item.company_id === 4">マスターピース</template>
                  <template v-if="item.company_id === 5">マスタークライアント</template>
                </div>
              </td>
            </template>
            <template v-if="office_id">
              <td class="table__tr__td">
                <div class="office">
                  <template v-if="item.office_id === 0"></template>
                  <template v-if="item.office_id === 1">仙台</template>
                  <template v-if="item.office_id === 3">名古屋</template>
                  <template v-if="item.office_id === 4">福岡</template>
                  <template v-if="item.office_id === 6">大宮</template>
                  <template v-if="item.office_id === 7">高松</template>
                  <template v-if="item.office_id === 9">東京</template>
                  <template v-if="item.office_id === 10">大阪</template>
                  <template v-if="item.office_id === 2">札幌</template>
                  <template v-if="item.office_id === 5">新宿</template>
                  <template v-if="item.office_id === 8">高崎</template>
                </div>
              </td>
            </template>
            <template v-if="person"><td class="table__tr__td"><div>{{item.person}}</div></td></template>
            <template v-if="product_name"><td class="table__tr__td"><div class="product">{{item.product_name}}</div></td></template>
            <template v-if="payments_number"><td class="table__tr__td"><div>{{item.payments_number}}</div></td></template>
            <template v-if="text_payment_period_start"><td class="table__tr__td"><div class="date">{{item.text_payment_period_start}}</div></td></template>
            <template v-if="text_payment_period_end"><td class="table__tr__td"><div class="date">{{item.text_payment_period_end}}</div></td></template>
            <template v-if="service_period_start"><td class="table__tr__td"><div class="date">{{item.service_period_start}}</div></td></template>
            <template v-if="service_period_end"><td class="table__tr__td"><div class="date">{{item.service_period_end}}</div></td></template>
            <template v-if="administrative_expense"><td class="table__tr__td"><div>{{item.administrative_expense.toLocaleString()}}</div></td></template>
            <template v-if="first_month_deposit"><td class="table__tr__td"><div>{{item.first_month_deposit.toLocaleString()}}</div></td></template>
            <template v-if="first_month_deposit_method"><td class="table__tr__td"><div>{{item.first_month_deposit_method.toLocaleString()}}</div></td></template>
            <template v-if="first_month_deposit_check"><td class="table__tr__td"><div>{{item.first_month_deposit_check.toLocaleString()}}</div></td></template>
            <template v-if="admission_fee"><td class="table__tr__td"><div>{{item.admission_fee.toLocaleString()}}</div></td></template>
            <template v-if="admission_fee_method"><td class="table__tr__td"><div>{{item.admission_fee_method}}</div></td></template>
            <template v-if="admission_fee_check"><td class="table__tr__td"><div>{{item.admission_fee_check}}</div></td></template>
            <template v-if="deposit"><td class="table__tr__td"><div>{{item.deposit.toLocaleString()}}</div></td></template>
            <template v-if="deposit_method"><td class="table__tr__td"><div>{{item.deposit_method}}</div></td></template>
            <template v-if="deposit_check"><td class="table__tr__td"><div>{{item.deposit_check}}</div></td></template>
            <template v-if="deposit_refund_date"><td class="table__tr__td"><div class="date">{{item.deposit_refund_date}}</div></td></template>
            <template v-if="approval_date"><td class="table__tr__td"><div class="date">{{item.approval_date}}</div></td></template>
            <template v-if="approval_number"><td class="table__tr__td"><div class="number2">{{item.approval_number}}</div></td></template>
            <template v-if="delivery_date"><td class="table__tr__td"><div class="date">{{item.delivery_date}}</div></td></template>
            <template v-if="contract_collection_date"><td class="table__tr__td"><div class="date">{{item.contract_collection_date}}</div></td></template>
            <template v-if="factor_collection_date"><td class="table__tr__td"><div class="date">{{item.factor_collection_date}}</div></td></template>
            <template v-if="penalty_amount_limit"><td class="table__tr__td"><div class="date">{{item.penalty_amount_limit}}</div></td></template>
            <template v-if="penalty_plans_amount"><td class="table__tr__td"><div class="date">{{item.penalty_plans_amount}}</div></td></template>
            <template v-if="penalty_amount_date"><td class="table__tr__td"><div class="date">{{item.penalty_amount_date}}</div></td></template>
            <template v-if="penalty_real_amount"><td class="table__tr__td"><div class="date">{{item.penalty_real_amount}}</div></td></template>
            <template v-if="grade"><td class="table__tr__td"><div>{{item.grade}}</div></td></template>
            <!-- <template v&#45;if="point_s"><td class="table__tr__td"><div class="number">{{item.point_s}}</div></td></template> -->
            <!-- <template v&#45;if="point_c"><td class="table__tr__td"><div class="number">{{item.point_c}}</div></td></template> -->
            <!-- <template v&#45;if="point_k"><td class="table__tr__td"><div class="number">{{item.point_k}}</div></td></template> -->
            <!-- <template v&#45;if="point_s_bulk"><td class="table__tr__td"><div class="number">{{item.point_s_bulk}}</div></td></template> -->
            <!-- <template v&#45;if="point_c_bulk"><td class="table__tr__td"><div class="number">{{item.point_c_bulk}}</div></td></template> -->
            <!-- <template v&#45;if="point_k_bulk"><td class="table__tr__td"><div class="number">{{item.point_k_bulk}}</div></td></template> -->
            <!-- <template v&#45;if="point_total"><td class="table__tr__td"><div class="number">{{item.point_total}}</div></td></template> -->
            <template v-if="note"><td class="table__tr__td"><div class="note">{{item.note}}</div></td></template>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { getAPIURL } from '@/store/getters.js'
import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/contracts/search?limit=' + config.LIMIT

var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url,
  searchUrl: url,
  pageName: 'contract',
  pageNames: 'contracts'
}

export default {
  data () {
    return {
      real_amount_date_start: true,
      real_amount_date_end: true,

      id: true,
      contract_type: true,
      contract_date_start: true,
      contract_date_end: true,
      change_date: false,
      cancel_type: false,
      cancel_date: false,
      media: false,
      f_name: true,
      l_name: true,
      f_name_kana: false,
      l_name_kana: false,
      tel: true,
      tel2: false,
      address: true,
      address2: false,
      payment_type: true,
      text_type: true,
      amount: false,
      discount: false,
      // split_commission: false,
      // sales_commission: false,
      // sales_commission_head: false,
      // sales_commission_branch: false,
      pure_amount: false,
      // pure_amount_head: false,
      // pure_amount_branch: false,
      // old_amount: false,
      division_commission: false,
      total_amount: false,
      agency_commission: false,
      // agency_commission_head: false,
      // agency_commission_branch: false,
      agency_commission_own_installment: false,
      // purchase_amount: false,
      // purchase_amount_head: false,
      // purchase_amount_branch: false,
      only_total_amount: false,
      // only_total_amount_head: false,
      // only_total_amount_branch: false,
      deposit_amount: false,
      deposit_amount_date: false,
      down_payment: false,
      company_id: true,
      office_id: true,
      person: false,
      product_name: false,
      payments_number: false,
      text_payment_period_start: false,
      text_payment_period_end: false,
      service_period_start: false,
      service_period_end: false,
      administrative_expense: false,
      first_month_deposit: false,
      first_month_deposit_method: false,
      first_month_deposit_check: false,
      admission_fee: false,
      admission_fee_method: false,
      admission_fee_check: false,
      deposit: false,
      deposit_method: false,
      deposit_check: false,
      deposit_refund_date: false,
      approval_date: false,
      approval_number: false,
      delivery_date: false,
      contract_collection_date: false,
      factor_collection_date: false,
      penalty_amount_limit: false,
      penalty_plans_amount: false,
      penalty_amount_date: false,
      penalty_real_amount: false,
      grade: false,
      // point_s: false,
      // point_c: false,
      // point_k: false,
      // point_s_bulk: false,
      // point_c_bulk: false,
      // point_k_bulk: false,
      // point_total: true,
      note: true,

      query: '',
      order: -1,
      header: 'id',

      search: {
        id: '',
        contract_type: '',
        contract_date: [],
        real_amount_date: [],
        change_date: '',
        cancel_type: '',
        cancel_date: '',
        media: '',
        f_name: '',
        l_name: '',
        f_name_kana: '',
        l_name_kana: '',
        tel: '',
        tel2: '',
        address: '',
        address2: '',
        payment_type: '',
        text_type: '',
        amount: '',
        discount: '',
        // split_commission: '',
        // sales_commission: '',
        // sales_commission_head: '',
        // sales_commission_branch: '',
        pure_amount: '',
        // pure_amount_head: '',
        // pure_amount_branch: '',
        // old_amount: '',
        division_commission: '',
        total_amount: '',
        agency_commission: '',
        // agency_commission_head: '',
        // agency_commission_branch: '',
        agency_commission_own_installment: '',
        // purchase_amount: '',
        // purchase_amount_head: '',
        // purchase_amount_branch: '',
        only_total_amount: '',
        // only_total_amount_head: '',
        // only_total_amount_branch: '',
        deposit_amount: '',
        deposit_amount_date: '',
        down_payment: '',
        company_id: '',
        office_id: '',
        person: '',
        product_name: '',
        payments_number: '',
        text_payment_period_start: '',
        text_payment_period_end: '',
        service_period_start: '',
        service_period_end: '',
        administrative_expense: '',
        first_month_deposit: '',
        first_month_deposit_method: '',
        first_month_deposit_check: '',
        admission_fee: '',
        admission_fee_method: '',
        admission_fee_check: '',
        deposit: '',
        deposit_method: '',
        deposit_check: '',
        deposit_refund_date: '',
        approval_date: '',
        approval_number: '',
        delivery_date: '',
        contract_collection_date: '',
        factor_collection_date: '',
        penalty_amount_limit: '',
        penalty_plans_amount: '',
        penalty_amount_date: '',
        penalty_real_amount: '',
        grade: '',
        // point_s: '',
        // point_c: '',
        // point_k: '',
        // point_s_bulk: '',
        // point_c_bulk: '',
        // point_k_bulk: '',
        // point_total: '',
        note: '',

        not_id: '',
        not_contract_type: '',
        not_contract_date: [],
        not_real_amount_date: [],
        not_change_date: '',
        not_cancel_type: '',
        not_cancel_date: '',
        not_media: '',
        not_f_name: '',
        not_l_name: '',
        not_f_name_kana: '',
        not_l_name_kana: '',
        not_tel: '',
        not_tel2: '',
        not_address: '',
        not_address2: '',
        not_payment_type: '',
        not_text_type: '',
        not_amount: '',
        not_discount: '',
        // not_split_commission: '',
        // not_sales_commission: '',
        // not_sales_commission_head: '',
        // not_sales_commission_branch: '',
        not_pure_amount: '',
        // not_pure_amount_head: '',
        // not_pure_amount_branch: '',
        // not_old_amount: '',
        not_division_commission: '',
        not_total_amount: '',
        not_agency_commission: '',
        // not_agency_commission_head: '',
        // not_agency_commission_branch: '',
        not_agency_commission_own_installment: '',
        // not_purchase_amount: '',
        // not_purchase_amount_head: '',
        // not_purchase_amount_branch: '',
        not_only_total_amount: '',
        // not_only_total_amount_head: '',
        // not_only_total_amount_branch: '',
        not_deposit_amount: '',
        not_deposit_amount_date: '',
        not_down_payment: '',
        not_company_id: '',
        not_office_id: '',
        not_person: '',
        not_product_name: '',
        not_payments_number: '',
        not_text_payment_period_start: '',
        not_text_payment_period_end: '',
        not_service_period_start: '',
        not_service_period_end: '',
        not_administrative_expense: '',
        not_first_month_deposit: '',
        not_first_month_deposit_method: '',
        not_first_month_deposit_check: '',
        not_admission_fee: '',
        not_admission_fee_method: '',
        not_admission_fee_check: '',
        not_deposit: '',
        not_deposit_method: '',
        not_deposit_check: '',
        not_deposit_refund_date: '',
        not_approval_date: '',
        not_approval_number: '',
        not_delivery_date: '',
        not_contract_collection_date: '',
        not_factor_collection_date: '',
        not_penalty_amount_limit: '',
        not_penalty_plans_amount: '',
        not_penalty_amount_date: '',
        not_penalty_real_amount: '',
        not_grade: '',
        // not_point_s: '',
        // not_point_c: '',
        // not_point_k: '',
        // not_point_s_bulk: '',
        // not_point_c_bulk: '',
        // not_point_k_bulk: '',
        // not_point_total: '',
        not_note: ''
      }
    }
  },

  computed: {
    max () {
      return this.$store.getters.max
    },

    sum () {
      return this.$store.getters.sum
    },

    contracts () {
      return this.$store.getters.contracts
    }
  },

  methods: {
    offset (e) {
      this.$store.dispatch('SCROLL', {
        this: this,
        e: e,
        obj: obj
      })
    },

    searchTable (e) {
      this.$store.dispatch('SEARCH', {
        this: this,
        e: e,
        obj: obj
      })
    },

    setItem () {
      console.log('setItem')

      const object = {
        column_id: this.id,
        column_contract_type: this.contract_type,
        column_contract_date_start: this.contract_date_start,
        column_contract_date_end: this.contract_date_end,
        column_real_amount_date: this.real_amount_date,
        column_change_date: this.change_date,
        column_cancel_type: this.cancel_type,
        column_cancel_date: this.cancel_date,
        column_media: this.media,
        column_f_name: this.f_name,
        column_l_name: this.l_name,
        column_f_name_kana: this.f_name_kana,
        column_l_name_kana: this.l_name_kana,
        column_tel: this.tel,
        column_tel2: this.tel2,
        column_address: this.address,
        column_address2: this.address2,
        column_payment_type: this.payment_type,
        column_text_type: this.text_type,
        column_amount: this.amount,
        column_discount: this.discount,
        // column_split_commission: this.split_commission,
        // column_sales_commission: this.sales_commission,
        // column_sales_commission_head: this.sales_commission_head,
        // column_sales_commission_branch: this.sales_commission_branch,
        column_pure_amount: this.pure_amount,
        // column_pure_amount_head: this.pure_amount_head,
        // column_pure_amount_branch: this.purchase_amount_branch,
        // column_old_amount: this.old_amount,
        column_division_commission: this.division_commission,
        column_total_amount: this.total_amount,
        column_agency_commission: this.agency_commission,
        // column_agency_commission_head: this.agency_commission_head,
        // column_agency_commission_branch: this.agency_commission_branch,
        column_agency_commission_own_installment: this.agency_commission_own_installment,
        // column_purchase_amount: this.purchase_amount,
        // column_purchase_amount_head: this.purchase_amount_head,
        // column_purchase_amount_branch: this.purchase_amount_branch,
        column_only_total_amount: this.only_total_amount,
        // column_only_total_amount_head: this.only_total_amount_head,
        // column_only_total_amount_branch: this.only_total_amount_branch,
        column_deposit_amount: this.deposit_amount,
        column_deposit_amount_date: this.deposit_amount_date,
        column_down_payment: this.down_payment,
        column_company_id: this.company_id,
        column_office_id: this.office_id,
        column_person: this.person,
        column_product_name: this.product_name,
        column_payments_number: this.payments_number,
        column_text_payment_period_start: this.text_payment_period_start,
        column_text_payment_period_end: this.text_payment_period_end,
        column_service_period_start: this.service_period_start,
        column_service_period_end: this.service_period_end,
        column_administrative_expense: this.administrative_expense,
        column_first_month_deposit: this.first_month_deposit,
        column_first_month_deposit_method: this.first_month_deposit_method,
        column_first_month_deposit_check: this.first_month_deposit_check,
        column_admission_fee: this.admission_fee,
        column_admission_fee_method: this.admission_fee_method,
        column_admission_fee_check: this.admission_fee_check,
        column_deposit: this.deposit,
        column_deposit_method: this.deposit_method,
        column_deposit_check: this.deposit_check,
        column_deposit_refund_date: this.deposit_refund_date,
        column_approval_date: this.approval_date,
        column_approval_number: this.approval_number,
        column_delivery_date: this.delivery_date,
        column_contract_collection_date: this.contract_collection_date,
        column_factor_collection_date: this.factor_collection_date,
        column_penalty_amount_limit: this.penalty_amount_limit,
        column_penalty_plans_amount: this.penalty_plans_amount,
        column_penalty_amount_date: this.penalty_amount_date,
        column_penalty_real_amount: this.penalty_real_amount,
        column_grade: this.grade,
        // column_point_s: this.point_s,
        // column_point_c: this.point_c,
        // column_point_k: this.point_k,
        // column_point_s_bulk: this.point_s_bulk,
        // column_point_c_bulk: this.point_c_bulk,
        // column_point_k_bulk: this.point_k_bulk,
        // column_point_total: this.point_total,
        column_note: this.note
      }
      localStorage.setItem('ContractsOriginSearch', JSON.stringify(object))
    },

    getItem () {
      console.log('getItem')

      const object = JSON.parse(localStorage.getItem('ContractsOriginSearch'))
      this.id = object['column_id']
      this.contract_type = object['column_contract_type']
      this.contract_date_start = object['column_contract_date_start']
      this.contract_date_end = object['column_contract_date_end']
      this.real_amount_date = object['column_real_amount_date']
      this.change_date = object['column_change_date']
      this.cancel_type = object['column_cancel_type']
      this.cancel_date = object['column_cancel_date']
      this.media = object['column_media']
      this.f_name = object['column_f_name']
      this.l_name = object['column_l_name']
      this.f_name_kana = object['column_f_name_kana']
      this.l_name_kana = object['column_l_name_kana']
      this.tel = object['column_tel']
      this.tel2 = object['column_tel2']
      this.address = object['column_address']
      this.address2 = object['column_address2']
      this.payment_type = object['column_payment_type']
      this.text_type = object['column_text_type']
      this.amount = object['column_amount']
      this.discount = object['column_discount']
      // this.split_commission = object['column_split_commission']
      // this.sales_commission = object['column_sales_commission']
      // this.sales_commission_head = object['column_sales_commission_head']
      // this.sales_commission_branch = object['column_sales_commission_branch']
      this.pure_amount = object['column_pure_amount']
      // this.pure_amount_head = object['column_pure_amount_head']
      // this.pure_amount_branch = object['column_pure_amount_branch']
      // this.old_amount = object['column_old_amount']
      this.division_commission = object['column_division_commission']
      this.total_amount = object['column_total_amount']
      this.agency_commission = object['column_agency_commission']
      // this.agency_commission_head = object['column_agency_commission_head']
      // this.agency_commission_branch = object['column_agency_commission_branch']
      this.agency_commission_own_installment = object['column_agency_commission_own_installment']
      // this.purchase_amount = object['column_purchase_amount']
      // this.purchase_amount_head = object['column_purchase_amount_head']
      // this.purchase_amount_branch = object['column_purchase_amount_branch']
      this.only_total_amount = object['column_only_total_amount']
      // this.only_total_amount_head = object['column_only_total_amount_head']
      // this.only_total_amount_branch = object['column_only_total_amount_branch']
      this.deposit_amount = object['column_deposit_amount']
      this.deposit_amount_date = object['column_deposit_amount_date']
      this.down_payment = object['column_down_payment']
      this.company_id = object['column_company_id']
      this.office_id = object['column_office_id']
      this.person = object['column_person']
      this.product_name = object['column_product_name']
      this.payments_number = object['column_payments_number']
      this.text_payment_period_start = object['column_text_payment_period_start']
      this.text_payment_period_end = object['column_text_payment_period_end']
      this.service_period_start = object['column_service_period_start']
      this.service_period_end = object['column_service_period_end']
      this.administrative_expense = object['column_administrative_expense']
      this.first_month_deposit = object['column_first_month_deposit']
      this.first_month_deposit_method = object['column_first_month_deposit_method']
      this.first_month_deposit_check = object['column_first_month_deposit_check']
      this.admission_fee = object['column_admission_fee']
      this.admission_fee_method = object['column_admission_fee_method']
      this.admission_fee_check = object['column_admission_fee_check']
      this.deposit = object['column_deposit']
      this.deposit_method = object['column_deposit_method']
      this.deposit_check = object['column_deposit_check']
      this.deposit_refund_date = object['column_deposit_refund_date']
      this.approval_date = object['column_approval_date']
      this.approval_number = object['column_approval_number']
      this.delivery_date = object['column_delivery_date']
      this.contract_collection_date = object['column_contract_collection_date']
      this.factor_collection_date = object['column_factor_collection_date']
      this.penalty_amount_limit = object['column_penalty_amount_limit']
      this.penalty_plans_amount = object['column_penalty_plans_amount']
      this.penalty_amount_date = object['column_penalty_amount_date']
      this.penalty_real_amount = object['column_penalty_real_amount']
      this.grade = object['column_grade']
      // this.point_s = object['column_point_s']
      // this.point_c = object['column_point_c']
      // this.point_k = object['column_point_k']
      // this.point_s_bulk = object['column_point_s_bulk']
      // this.point_c_bulk = object['column_point_c_bulk']
      // this.point_k_bulk = object['column_point_k_bulk']
      // this.point_total = object['column_point_total']
      this.note = object['column_note']
    },

    greet (col) {
      this[col] = !this[col]
    },

    reset () {
      this.real_amount_date_start = false
      this.real_amount_date_end = false

      this.id = false
      this.contract_type = false
      this.contract_date_start = false
      this.contract_date_end = false
      this.change_date = false
      this.cancel_type = false
      this.cancel_date = false
      this.media = false
      this.f_name = false
      this.l_name = false
      this.f_name_kana = false
      this.l_name_kana = false
      this.tel = false
      this.tel2 = false
      this.address = false
      this.address2 = false
      this.payment_type = false
      this.text_type = false
      this.amount = false
      this.discount = false
      // this.split_commission = false
      // this.sales_commission = false
      // this.sales_commission_head = false
      // this.sales_commission_branch = false
      this.pure_amount = false
      // this.pure_amount_head = false
      // this.pure_amount_branch = false
      // this.old_amount = false
      this.division_commission = false
      this.total_amount = false
      this.agency_commission = false
      // this.agency_commission_head = false
      // this.agency_commission_branch = false
      this.agency_commission_own_installment = false
      // this.purchase_amount = false
      // this.purchase_amount_head = false
      // this.purchase_amount_branch = false
      this.only_total_amount = false
      // this.only_total_amount_head = false
      // this.only_total_amount_branch = false
      this.deposit_amount = false
      this.deposit_amount_date = false
      this.down_payment = false
      this.company_id = false
      this.office_id = false
      this.person = false
      this.product_name = false
      this.payments_number = false
      this.text_payment_period_start = false
      this.text_payment_period_end = false
      this.service_period_start = false
      this.service_period_end = false
      this.administrative_expense = false
      this.first_month_deposit = false
      this.first_month_deposit_method = false
      this.first_month_deposit_check = false
      this.admission_fee = false
      this.admission_fee_method = false
      this.admission_fee_check = false
      this.deposit = false
      this.deposit_method = false
      this.deposit_check = false
      this.deposit_refund_date = false
      this.approval_date = false
      this.approval_number = false
      this.delivery_date = false
      this.contract_collection_date = false
      this.factor_collection_date = false
      this.penalty_amount_limit = false
      this.penalty_plans_amount = false
      this.penalty_amount_date = false
      this.penalty_real_amount = false
      this.grade = false
      // this.point_s = false
      // this.point_c = false
      // this.point_k = false
      // this.point_s_bulk = false
      // this.point_c_bulk = false
      // this.point_k_bulk = false
      // this.point_total = false
      this.note = false
    },

    all () {
      this.real_amount_date_start = true
      this.real_amount_date_end = true

      this.id = true
      this.contract_type = true
      this.contract_date_start = true
      this.contract_date_end = true
      this.change_date = true
      this.cancel_type = true
      this.cancel_date = true
      this.media = true
      this.f_name = true
      this.l_name = true
      this.f_name_kana = true
      this.l_name_kana = true
      this.tel = true
      this.tel2 = true
      this.address = true
      this.address2 = true
      this.payment_type = true
      this.text_type = true
      this.amount = true
      this.discount = true
      // this.split_commission = true
      // this.sales_commission = true
      // this.sales_commission_head = true
      // this.sales_commission_branch = true
      this.pure_amount = true
      // this.pure_amount_head = true
      // this.pure_amount_branch = true
      // this.old_amount = true
      this.division_commission = true
      this.total_amount = true
      this.agency_commission = true
      // this.agency_commission_head = true
      // this.agency_commission_branch = true
      this.agency_commission_own_installment = true
      // this.purchase_amount = true
      // this.purchase_amount_head = true
      // this.purchase_amount_branch = true
      this.only_total_amount = true
      // this.only_total_amount_head = true
      // this.only_total_amount_branch = true
      this.deposit_amount = true
      this.deposit_amount_date = true
      this.down_payment = true
      this.company_id = true
      this.office_id = true
      this.person = true
      this.product_name = true
      this.payments_number = true
      this.text_payment_period_start = true
      this.text_payment_period_end = true
      this.service_period_start = true
      this.service_period_end = true
      this.administrative_expense = true
      this.first_month_deposit = true
      this.first_month_deposit_method = true
      this.first_month_deposit_check = true
      this.admission_fee = true
      this.admission_fee_method = true
      this.admission_fee_check = true
      this.deposit = true
      this.deposit_method = true
      this.deposit_check = true
      this.deposit_refund_date = true
      this.approval_date = true
      this.approval_number = true
      this.delivery_date = true
      this.contract_collection_date = true
      this.factor_collection_date = true
      this.penalty_amount_limit = true
      this.penalty_plans_amount = true
      this.penalty_amount_date = true
      this.penalty_real_amount = true
      this.grade = true
      // this.point_s = true
      // this.point_c = true
      // this.point_k = true
      // this.point_s_bulk = true
      // this.point_c_bulk = true
      // this.point_k_bulk = true
      // this.point_total = true
      this.note = true
    },

    tmp1 () { // 一括お支払計算書
      this.reset()
      this.id = true
      this.contract_type = true
      this.contract_date_start = true
      this.f_name = true
      this.l_name = true
      this.payment_type = true
      this.text_type = true
      this.amount = true
      // this.purchase_amount = true
      this.deposit_amount_date = true
      this.company_id = true
      this.office_id = true
      this.approval_number = true
    },

    tmp2 () { // 信販・自社お支払計算書
      this.reset()
      this.id = true
      this.contract_type = true
      this.contract_date_start = true
      this.f_name = true
      this.l_name = true
      this.payment_type = true
      this.text_type = true
      this.amount = true
      // this.purchase_amount = true
      this.company_id = true
      this.office_id = true
      this.approval_date = true
      this.approval_number = true
    },

    tmp3 () { // 売掛金(一括)
      this.reset()
      this.id = true
      this.contract_type = true
      this.contract_date_start = true
      this.f_name = true
      this.l_name = true
      this.payment_type = true
      // this.pure_amount_head = true
      // this.pure_amount_branch = true
      // this.purchase_amount = true
      // this.purchase_amount_head = true
      // this.purchase_amount_branch = true
      this.deposit_amount = true
      this.deposit_amount_date = true
      this.company_id = true
      this.office_id = true
      this.note = true
    },

    tmp4 () { // 売掛金(自社)
      this.reset()
      this.id = true
      this.contract_type = true
      this.contract_date_start = true
      this.f_name = true
      this.l_name = true
      this.payment_type = true
      this.pure_amount = true
      // this.pure_amount_head = true
      // this.pure_amount_branch = true
      // this.purchase_amount = true
      // this.purchase_amount_head = true
      // this.purchase_amount_branch = true
      this.deposit_amount = true
      this.deposit_amount_date = true
      this.company_id = true
      this.office_id = true
      this.note = true
    },

    tmp5 () { // 売掛金(信販)
      this.reset()
      this.id = true
      this.contract_type = true
      this.contract_date_start = true
      this.f_name = true
      this.l_name = true
      this.payment_type = true
      // this.pure_amount_head = true
      // this.pure_amount_branch = true
      // this.agency_commission_head = true
      // this.agency_commission_branch = true
      // this.purchase_amount = true
      // this.purchase_amount_head = true
      // this.purchase_amount_branch = true
      this.deposit_amount = true
      this.deposit_amount_date = true
      this.company_id = true
      this.office_id = true
      this.note = true
    },

    sortTable (header) {
      this.order = this.order * -1
      this.header = header
    }
  },
  ready: function () {
    console.log('ready')
    this.getItem()
  }
}
</script>

<style lang="scss" scoped>
@charset "UTF-8";
/* line 1, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/clearfix.scss */
.clearfix:after {
  content: "";
  display: block;
  clear: both;
}

/*! sanitize.css v3.3.0 | CC0 1.0 Public Domain | github.com/10up/sanitize.css */
/*
 * Normalization
 */
/* line 9, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
abbr[title] {
  text-decoration: underline;
  text-decoration: underline dotted;
}

/* line 14, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
audio:not([controls]) {
  display: none;
}

/* line 18, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
b,
strong {
  font-weight: bolder;
}

/* line 23, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
button {
  -webkit-appearance: button;
  overflow: visible;
}

/* line 30, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}
/* line 35, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
button:-moz-focusring,
input:-moz-focusring {
  outline: 1px dotted ButtonText;
}

/* line 40, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
button,
select {
  text-transform: none;
}

/* line 45, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
details {
  display: block;
}

/* line 49, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
hr {
  overflow: visible;
}

/* line 53, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
html {
  -ms-overflow-style: -ms-autohiding-scrollbar;
  overflow-y: scroll;
  -webkit-text-size-adjust: 100%;
}

/* line 59, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
input {
  -webkit-border-radius: 0;
}
/* line 62, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
input[type="button"], input[type="reset"], input[type="submit"] {
  -webkit-appearance: button;
}
/* line 68, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
input[type="number"] {
  width: auto;
}
/* line 72, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
input[type="search"] {
  -webkit-appearance: textfield;
}
/* line 75, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
input[type="search"]::-webkit-search-cancel-button, input[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}

/* line 82, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
main {
  display: block;
}

/* line 86, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
pre {
  overflow: auto;
}

/* line 90, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
progress {
  display: inline-block;
}

/* line 94, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
summary {
  display: block;
}

/* line 98, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
svg:not(:root) {
  overflow: hidden;
}

/* line 102, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
template {
  display: none;
}

/* line 106, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
textarea {
  overflow: auto;
}

/* line 110, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
[hidden] {
  display: none;
}

/*
 * Universal inheritance
 */
/* line 118, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
*,
::before,
::after {
  box-sizing: inherit;
}

/* line 124, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
* {
  font-size: inherit;
  line-height: inherit;
}

/* line 129, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
::before,
::after {
  text-decoration: inherit;
  vertical-align: inherit;
}

/* line 135, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
button,
input,
select,
textarea {
  font-family: inherit;
  font-style: inherit;
  font-weight: inherit;
}

/*
 * Opinionated defaults
 */
/* line 152, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
* {
  margin: 0;
  padding: 0;
}

/* line 159, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
*,
::before,
::after {
  border-style: solid;
  border-width: 0;
}

/* line 168, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
a,
area,
button,
input,
label,
select,
textarea,
[tabindex] {
  -ms-touch-action: manipulation;
      touch-action: manipulation;
}

/* line 185, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
select::-ms-expand {
  display: none;
}
/* line 189, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
select::-ms-value {
  color: currentColor;
}

/* line 196, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
svg {
  fill: currentColor;
}

/* line 202, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
[aria-busy="true"] {
  cursor: progress;
}

/* line 208, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
[aria-controls] {
  cursor: pointer;
}

/* line 214, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
[aria-disabled] {
  cursor: default;
}

/* line 220, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
[hidden][aria-hidden="false"] {
  clip: rect(0 0 0 0);
  display: inherit;
  position: absolute;
}
/* line 225, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
[hidden][aria-hidden="false"]:focus {
  clip: auto;
}

/*
 * Configurable defaults
 */
/* line 238, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
* {
  background-repeat: no-repeat;
}

/* line 244, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
:root {
  background-color: #ffffff;
  box-sizing: border-box;
  color: #000000;
  cursor: default;
  font: 100%/1.5 sans-serif;
}

/* line 254, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
a {
  text-decoration: none;
}

/* line 260, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
audio,
canvas,
iframe,
img,
svg,
video {
  vertical-align: middle;
}

/* line 271, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
button,
input,
select,
textarea {
  background-color: transparent;
  color: inherit;
}

/* line 281, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
button,
[type="button"],
[type="date"],
[type="datetime"],
[type="datetime-local"],
[type="email"],
[type="month"],
[type="number"],
[type="password"],
[type="reset"],
[type="search"],
[type="submit"],
[type="tel"],
[type="text"],
[type="time"],
[type="url"],
[type="week"],
select,
textarea {
  min-height: 1.5em;
}

/* line 305, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
code,
kbd,
pre,
samp {
  font-family: monospace, monospace;
}

/* line 314, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
nav ol,
nav ul {
  list-style: none;
}

/* line 321, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
small {
  font-size: 75%;
}

/* line 327, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
table {
  border-collapse: collapse;
  border-spacing: 0;
}

/* line 334, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
textarea {
  resize: vertical;
}

/* line 340, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
::-moz-selection {
  background-color: #b3d4fc;
  color: #ffffff;
  text-shadow: none;
}

/* line 346, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/setting/sanitize.scss */
::-moz-selection {
  background-color: #b3d4fc;
  color: #ffffff;
  text-shadow: none;
}
::selection {
  background-color: #b3d4fc;
  color: #ffffff;
  text-shadow: none;
}

@-webkit-keyframes devise {
  0% {
    background: #2e3c54;
  }
  50% {
    background: #2e5451;
  }
  100% {
    background: #2e3c54;
  }
}

@keyframes devise {
  0% {
    background: #2e3c54;
  }
  50% {
    background: #2e5451;
  }
  100% {
    background: #2e3c54;
  }
}
/* line 1, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
#slide_btn {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 50px;
  height: 50px;
  color: #455A64;
  background: #e4e4e4;
  -webkit-transition: 0.5s cubic-bezier(0.74, -0.18, 0.18, 1.49) 0s;
  transition: 0.5s cubic-bezier(0.74, -0.18, 0.18, 1.49) 0s;
}
/* line 12, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
#slide_btn i {
  font-size: 31px;
}

/* line 16, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--1 {
  width: 50px;
  height: 25px;
  text-align: center;
  background: #a4cf30;
  border-right: solid 1px #eee;
  border-bottom: solid 1px #eee;
  -webkit-transition: .5s ease-in-out 0s;
  transition: .5s ease-in-out 0s;
}
/* line 24, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--1:hover {
  background: #6877ff;
}
/* line 27, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--1 a {
  display: inline-block;
  width: 50px;
  padding: 4px 0 0 0;
  color: #fff;
  font-size: 12px;
}

/* line 35, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--2 {
  width: 25px;
  height: 25px;
  text-align: center;
  background: #a4cf30;
  -webkit-transition: .5s ease-in-out 0s;
  transition: .5s ease-in-out 0s;
}
/* line 41, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--2:hover {
  background: #6877ff;
}
/* line 44, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--2 a {
  display: inline-block;
  width: 25px;
  padding: 4px 0 0 0;
  color: #fff;
  font-size: 12px;
}

/* line 52, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--3 {
  display: block;
  float: left;
  border-right: solid 1px #fff;
  border-top: solid 1px #fff;
  font-size: 11px;
  font-weight: bold;
  color: #444;
  width: 135px;
  height: 25px;
  background: #e4e4e4;
  -webkit-transition: .5s ease-in-out 0s;
  transition: .5s ease-in-out 0s;
}
/* line 64, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--3:hover {
  background: #6877ff;
  color: #fff;
}
/* line 68, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--3--active {
  background: #2e3c54;
  color: #fff;
}

/* line 73, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--4 {
  color: #fff;
  background: #e8384f;
}

/* line 77, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--5 {
  color: #fff;
  background: #2d2d2d;
}

/* line 81, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--6 {
  position: absolute;
  top: 20px;
  right: 0;
  background: #2e3c54;
  height: 30px;
  width: 205px;
  cursor: pointer;
}
/* line 89, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--6 a {
  color: #fff;
  width: 100%;
  height: 100%;
  display: block;
  padding-top: 3px;
  -webkit-transition: .5s ease-in-out 0s;
  transition: .5s ease-in-out 0s;
}
/* line 96, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--6 a:hover {
  background: #6877ff;
  color: #fff;
}

/* line 102, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--7 {
  position: absolute;
  top: 20px;
  right: 210px;
  background: #2e3c54;
  height: 30px;
  width: 205px;
  cursor: pointer;
}
/* line 110, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--7 a {
  color: #fff;
  width: 100%;
  height: 100%;
  display: block;
  padding-top: 3px;
  -webkit-transition: .5s ease-in-out 0s;
  transition: .5s ease-in-out 0s;
}
/* line 117, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--7 a:hover {
  background: #6877ff;
  color: #fff;
}

/* line 123, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--a {
  width: 25%;
  height: 25px;
  text-align: center;
  background: #37C5AB;
  position: fixed;
  top: 50px;
  left: 0;
  z-index: 2;
  -webkit-transition: 0.5s cubic-bezier(0.74, -0.18, 0.18, 1.49) 0s;
  transition: 0.5s cubic-bezier(0.74, -0.18, 0.18, 1.49) 0s;
}
/* line 133, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--a:hover {
  background: #6877ff;
}
/* line 136, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--a a {
  display: block;
  padding-top: 3px;
  width: 100%;
  height: 100%;
  color: #fff;
  font-size: 12px;
}

/* line 145, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--b {
  width: 25%;
  height: 25px;
  text-align: center;
  background: #E8384F;
  position: fixed;
  top: 50px;
  left: 25%;
  z-index: 2;
  -webkit-transition: 0.5s cubic-bezier(0.74, -0.18, 0.18, 1.49) 0s;
  transition: 0.5s cubic-bezier(0.74, -0.18, 0.18, 1.49) 0s;
}
/* line 155, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--b:hover {
  background: #6877ff;
}
/* line 158, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--b a {
  display: block;
  padding-top: 3px;
  width: 100%;
  height: 100%;
  color: #fff;
  font-size: 12px;
}

/* line 167, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--c {
  width: 50%;
  height: 25px;
  text-align: center;
  background: #A4CF30;
  position: fixed;
  top: 50px;
  left: 50%;
  z-index: 2;
  -webkit-transition: 0.5s cubic-bezier(0.74, -0.18, 0.18, 1.49) 0s;
  transition: 0.5s cubic-bezier(0.74, -0.18, 0.18, 1.49) 0s;
}
/* line 177, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--c:hover {
  background: #6877ff;
}
/* line 180, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--c a {
  display: block;
  padding-top: 3px;
  width: 100%;
  height: 100%;
  color: #fff;
  font-size: 12px;
}

/* line 189, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--d {
  width: 100%;
  height: 40px;
  text-align: center;
  background: #20AAEA;
  position: fixed;
  bottom: 0;
  color: #fff;
  z-index: 2;
  -webkit-transition: 0.5s cubic-bezier(0.74, -0.18, 0.18, 1.49) 0s;
  transition: 0.5s cubic-bezier(0.74, -0.18, 0.18, 1.49) 0s;
}
/* line 199, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--d:hover {
  background: #6877ff;
}
/* line 202, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--d a {
  display: block;
  padding-top: 3px;
  width: 100%;
  height: 100%;
  color: #fff;
  font-size: 12px;
}

/* line 211, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--e {
  width: 50%;
  height: 25px;
  text-align: center;
  background: #37C5AB;
  position: fixed;
  top: 50px;
  left: 0;
  z-index: 2;
  -webkit-transition: 0.5s cubic-bezier(0.74, -0.18, 0.18, 1.49) 0s;
  transition: 0.5s cubic-bezier(0.74, -0.18, 0.18, 1.49) 0s;
}
/* line 221, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--e:hover {
  background: #6877ff;
}
/* line 224, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--e a {
  display: block;
  padding-top: 3px;
  width: 100%;
  height: 100%;
  color: #fff;
  font-size: 12px;
}

/* line 233, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--f {
  width: 100%;
  height: 25px;
  text-align: center;
  background: #37C5AB;
  top: 50px;
  left: 0;
  z-index: 2;
  -webkit-transition: 0.5s cubic-bezier(0.74, -0.18, 0.18, 1.49) 0s;
  transition: 0.5s cubic-bezier(0.74, -0.18, 0.18, 1.49) 0s;
}
/* line 242, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--f:hover {
  background: #6877ff;
}
/* line 245, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--f a {
  display: block;
  padding-top: 3px;
  width: 100%;
  height: 100%;
  color: #fff;
  font-size: 12px;
}

/* line 254, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--new {
  float: none;
  width: 152px;
  height: 25px;
  background: #20AAEA;
  margin: 0 0 0 0px;
  -webkit-transition: .5s ease-in-out 0s;
  transition: .5s ease-in-out 0s;
}
/* line 261, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--new:hover {
  background: #6877ff;
}
/* line 264, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.btn--new a {
  display: inline-block;
  width: 152px;
  height: 25px;
  color: #fff;
  font-size: 12px;
  padding: 3px 0 0 0;
}

/* line 273, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.menu__button {
  width: 100%;
  height: 35px;
}
/* line 276, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.menu__button a, .menu__button p {
  color: #fff;
  font-size: 13px;
  height: 100%;
  width: 100%;
  display: inline-block;
  line-height: 2.9;
  padding-left: 10px;
  -webkit-transition: .2s ease-in-out 0s;
  transition: .2s ease-in-out 0s;
}
/* line 285, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/button/button.scss */
.menu__button a:hover, .menu__button p:hover {
  background: #2d2d2d;
}

/* line 1, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/form/form.scss */
input {
  width: 100%;
  height: 100%;
}

/* line 5, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/form/form.scss */
.error_explanation {
  color: #fff;
  font-size: 11px;
  position: absolute;
  top: 9px;
  left: 65px;
  z-index: 1;
}
/* line 13, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/form/form.scss */
.error_explanation ul li {
  display: inline;
}

/* line 2, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/layout/side.scss */
body.open header button#slide_btn {
  -webkit-transform: translateX(150px);
          transform: translateX(150px);
}

/* line 6, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/layout/side.scss */
body.open article div button.btn--a,
body.open article div button.btn--b,
body.open article div button.btn--c,
body.open article div button.btn--e,
body.open article div div.pay_box button.btn--c {
  -webkit-transform: translateX(150px);
          transform: translateX(150px);
}

/* line 15, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/layout/side.scss */
.menu {
  height: 100%;
  width: 150px;
  left: -150px;
  margin-top: -50px;
  background: #2e3c54;
  position: fixed;
  color: #fff;
  z-index: 1;
}

/* line 28, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/layout/side.scss */
.menu-i {
  margin-right: 10px;
}

/* line 31, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/layout/side.scss */
.fa-times {
  color: #FF5252;
}

/* line 32, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/layout/side.scss */
.fa-meh-o {
  color: #EA80FC;
}

/* line 33, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/layout/side.scss */
.fa-lock {
  color: #8C9EFF;
}

/* line 34, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/layout/side.scss */
.fa-file {
  color: #40C4FF;
}

/* line 35, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/layout/side.scss */
.fa-file-text {
  color: #64FFDA;
}

/* line 36, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/layout/side.scss */
.fa-users {
  color: #B2FF59;
}

/* line 37, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/layout/side.scss */
.fa-calendar-check-o {
  color: #FFEA00;
}

/* line 1, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/layout/footer.scss */
footer {
  height: 30px;
  width: 100%;
  position: fixed;
  bottom: 0;
  background: #2e3c54;
  opacity: 0.8;
}

/* line 1, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/layout/hba.scss */
html {
  height: 100%;
  position: relative;
}

/* line 5, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/layout/hba.scss */
body {
  background: #fff;
  position: relative;
  left: 0;
  height: 100%;
  padding-top: 50px;
  counter-reset: number number2;
  font-family: "FlopDesignFONT", "ヒラギノ角ゴ Pro W3", Hiragino Kaku Gothic Pro, "メイリオ", Meiryo, sans-serif;
}

/* line 25, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/layout/hba.scss */
.article--home {
  height: 100%;
}

/* line 28, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/layout/hba.scss */
.article--index {
  padding: 0 0 30px 0;
  height: 100%;
}

/* line 33, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/layout/hba.scss */
.article--new,
.article--show,
.article--edit {
  padding: 25px 0 40px 0;
  height: 100%;
  overflow: scroll;
}

/* line 1, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/layout/header.scss */
header {
  height: 50px;
  width: 100%;
  margin-top: -50px;
  background: #00bcd4;
  position: fixed;
  z-index: 1;
  background: -webkit-linear-gradient(315deg, #2e3c54, #2e3c54, #2e3c54);
  background: linear-gradient(135deg, #2e3c54, #2e3c54, #2e3c54);
}

/* line 11, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/layout/header.scss */
.page_title {
  font-size: 17px;
  font-weight: normal;
  color: #fff;
  padding-left: 100px;
  line-height: 3;
}

@media screen and (max-width: 600px) {
  /* line 2, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/advisors.scss */
  .window-new {
    background: ivory;
    min-height: 100vh;
  }
  /* line 6, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/advisors.scss */
  .window-new form input {
    border-bottom: solid 1px #eee;
    height: 40px;
    color: #000;
    padding: 0 10px;
  }
  /* line 12, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/advisors.scss */
  .window-new .win--btn--1 {
    color: #fff;
    background: #2e3c54;
    height: 30px;
    width: 100%;
    position: absolute;
    bottom: 30px;
    cursor: pointer;
    -webkit-transition: .5s ease-in-out 0s;
    transition: .5s ease-in-out 0s;
  }
  /* line 21, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/advisors.scss */
  .window-new .win--btn--1:hover {
    background: #6877ff;
    color: #fff;
  }
  /* line 25, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/advisors.scss */
  .window-new .win--btn--1:focus {
    background: #6877ff;
    color: #fff;
  }
  /* line 30, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/advisors.scss */
  .window-new .win--btn--2 {
    color: #fff;
    background: #333;
    height: 30px;
    width: 100%;
    position: absolute;
    bottom: 0;
    cursor: pointer;
    -webkit-transition: .5s ease-in-out 0s;
    transition: .5s ease-in-out 0s;
  }
  /* line 39, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/advisors.scss */
  .window-new .win--btn--2:hover {
    background: #6877ff;
    color: #fff;
  }
  /* line 43, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/advisors.scss */
  .window-new .win--btn--2:focus {
    background: #6877ff;
    color: #fff;
  }
}
/* line 50, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/advisors.scss */
.advisor__reset {
  -webkit-animation: devise 30s ease-in-out 0s infinite;
          animation: devise 30s ease-in-out 0s infinite;
  background: #2e3c54;
  min-height: 100vh;
  width: 100%;
}
/* line 55, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/advisors.scss */
.advisor__reset input, .advisor__reset select {
  font-family: sans-serif;
}
/* line 57, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/advisors.scss */
.advisor__reset input:focus, .advisor__reset select:focus {
  outline: 0;
  border: solid 2px #fff;
}
/* line 62, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/advisors.scss */
.advisor__reset .advisor__wrap {
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  background: #2e3c54;
  padding-top: 5%;
  padding-bottom: 5%;
  -webkit-animation: devise 30s ease-in-out 0s infinite;
          animation: devise 30s ease-in-out 0s infinite;
}
/* line 70, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/advisors.scss */
.advisor__reset .advisor__wrap h1 {
  text-align: center;
  color: #fff;
  font-weight: bold;
  font-size: 25px;
}
/* line 76, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/advisors.scss */
.advisor__reset .advisor__wrap h2 {
  text-align: center;
  color: #fff;
  font-weight: bold;
}
/* line 82, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/advisors.scss */
.advisor__reset .advisor__field {
  margin: 20px 0;
}
/* line 85, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/advisors.scss */
.advisor__reset .advisor__block {
  width: 90%;
  height: 40px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
}
/* line 91, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/advisors.scss */
.advisor__reset .advisor__block input {
  padding: 0 10px;
}
/* line 94, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/advisors.scss */
.advisor__reset .advisor__block select {
  width: 100%;
  height: 100%;
  padding-left: 5px;
}
/* line 98, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/advisors.scss */
.advisor__reset .advisor__block select option {
  background: #2e3c54;
}
/* line 103, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/advisors.scss */
.advisor__reset .advisor__action {
  width: 90%;
  height: 40px;
  margin: 20px auto;
  color: #fff;
  border: solid 2px #fff;
  -webkit-transition: .5s ease-in-out 0s;
  transition: .5s ease-in-out 0s;
}
/* line 110, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/advisors.scss */
.advisor__reset .advisor__action:hover {
  background: #6877ff;
  color: #fff;
  font-weight: bold;
  border: none;
}
/* line 116, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/advisors.scss */
.advisor__reset .advisor__action input {
  -webkit-transition: .5s ease-in-out 0s;
  transition: .5s ease-in-out 0s;
}
/* line 118, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/advisors.scss */
.advisor__reset .advisor__action input:focus {
  background: #6877ff;
  color: #fff;
  font-weight: bold;
  border: none;
}
/* line 125, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/advisors.scss */
.advisor__reset .advisor__action form {
  height: 100%;
}

/* line 5, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/contracts.scss */
.total_tr {
  background: #455a64 !important;
  color: #fff;
}

/* line 9, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/contracts.scss */
.search_tr {
  background: #2e5451 !important;
  color: #fff;
}
/* line 12, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/contracts.scss */
.search_tr div {
  padding: 0 !important;
  background: #fff;
  color: #000;
}

/* line 18, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/contracts.scss */
.eee {
  background: #eee;
}

/* line 26, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/contracts.scss */
.cont_new_wrapper_2 {
  width: 50%;
  float: left;
  min-width: 700px;
}

/* line 31, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/contracts.scss */
.cont_new_box, .cont_new_box2 {
  width: 25%;
  min-width: 350px;
  float: left;
}
/* line 35, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/contracts.scss */
.cont_new_box table, .cont_new_box2 table {
  width: 100%;
}
/* line 37, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/contracts.scss */
.cont_new_box table tr, .cont_new_box2 table tr {
  height: 25px;
}
/* line 41, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/contracts.scss */
.cont_new_box #agency, .cont_new_box2 #agency {
  border: solid 1px red;
}

/* line 45, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/contracts.scss */
.cont_new_box3 {
  width: 100%;
  min-width: 700px;
  float: left;
}
/* line 49, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/contracts.scss */
.cont_new_box3 .th {
  background: #e4e4e4;
  font-size: 11px;
  padding: 5px 0 0 10px;
  height: 25px;
  color: #444;
  font-weight: bold;
  border-bottom: solid 1px #dcd9d9;
}
/* line 58, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/contracts.scss */
.cont_new_box3 .td {
  font-size: 11px;
  height: 50px;
  font-weight: bold;
  border-right: solid 1px #eee;
  border-bottom: solid 1px #eee;
}
/* line 64, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/contracts.scss */
.cont_new_box3 .td textarea {
  padding: 10px;
  width: 100%;
  height: 100%;
}

/* line 71, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/contracts.scss */
.pay_box {
  width: 100%;
  min-width: 350px;
}
/* line 75, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/contracts.scss */
.pay_box table {
  width: 100%;
}
/* line 77, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/contracts.scss */
.pay_box table tr td.table__tr__td {
  min-width: 33px;
}
/* line 79, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/contracts.scss */
.pay_box table tr td.table__tr__td input[type="checkbox"] {
  display: none;
}
/* line 82, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/contracts.scss */
.pay_box table tr td.table__tr__td input[type="checkbox"]:checked + label {
  color: red;
  font-weight: bold;
}
/* line 86, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/contracts.scss */
.pay_box table tr td.table__tr__td label {
  color: #ccc;
}
/* line 91, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/contracts.scss */
.pay_box table tr:hover {
  background: none;
  color: #000;
}

/* line 99, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/contracts.scss */
.nested_contract_paymentdetails:before {
  counter-increment: number;
  content: counter(number) "";
  font-size: 11px;
  display: block;
  text-align: center;
  padding-top: 5px;
  height: 25px;
  position: relative;
  top: 1px;
  border-right: solid 1px #eee;
  border-bottom: solid 1px #eee;
}

/* line 114, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/contracts.scss */
.nested_contract_paymentdetails2s:before {
  counter-increment: number2;
  content: counter(number2) "";
  font-size: 11px;
  display: block;
  text-align: center;
  padding-top: 5px;
  height: 25px;
  position: relative;
  top: 1px;
  border-right: solid 1px #eee;
  border-bottom: solid 1px #eee;
}

/* line 128, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/contracts.scss */
.increment {
  min-width: 10px !important;
}

/* line 1, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/devise.scss */
.devise {
  background: #2e3c54;
  min-height: 100vh;
  width: 100%;
  -webkit-animation: devise 30s ease-in-out 0s infinite;
          animation: devise 30s ease-in-out 0s infinite;
}
/* line 6, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/devise.scss */
.devise .devise__p {
  color: #fff;
  position: absolute;
  right: 10px;
  bottom: 10px;
}

/* line 14, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/devise.scss */
.devise input, .devise select {
  font-family: sans-serif;
}
/* line 16, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/devise.scss */
.devise input:focus, .devise select:focus {
  outline: 0;
  border: solid 2px #fff;
}

/* line 22, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/devise.scss */
.devise_box {
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  background: #2e3c54;
  padding-top: 5%;
  padding-bottom: 5%;
  -webkit-animation: devise 30s ease-in-out 0s infinite;
          animation: devise 30s ease-in-out 0s infinite;
}
/* line 30, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/devise.scss */
.devise_box h1 {
  text-align: center;
  color: #fff;
  font-weight: bold;
  font-size: 25px;
}
/* line 36, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/devise.scss */
.devise_box h2 {
  text-align: center;
  color: #fff;
  font-weight: bold;
}
/* line 41, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/devise.scss */
.devise_box .flash_box {
  border-radius: 10px;
  color: #FFF;
  margin: 1rem 0;
  padding: 1rem;
}
/* line 46, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/devise.scss */
.devise_box .flash_box.is-success {
  border: 2px solid #58CF32;
  color: #58CF32;
}
/* line 50, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/devise.scss */
.devise_box .flash_box.is-error {
  border: 2px solid #e8384f;
  color: #e8384f;
}

/* line 56, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/devise.scss */
.field {
  margin: 20px 0;
}

/* line 59, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/devise.scss */
.login_user_f, .login_name_f, .login_email_f, .login_password_f, .login_type_s, .login_office_s, .login_hide_flag {
  width: 90%;
  height: 40px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
}
/* line 65, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/devise.scss */
.login_user_f input, .login_name_f input, .login_email_f input, .login_password_f input, .login_type_s input, .login_office_s input, .login_hide_flag input {
  padding: 0 10px;
}
/* line 68, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/devise.scss */
.login_user_f select, .login_name_f select, .login_email_f select, .login_password_f select, .login_type_s select, .login_office_s select, .login_hide_flag select {
  width: 100%;
  height: 100%;
  padding-left: 5px;
}
/* line 72, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/devise.scss */
.login_user_f select option, .login_name_f select option, .login_email_f select option, .login_password_f select option, .login_type_s select option, .login_office_s select option, .login_hide_flag select option {
  background: #2e3c54;
}

/* line 77, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/devise.scss */
.actions {
  width: 90%;
  height: 40px;
  margin: 20px auto;
  color: #fff;
  border: solid 2px #fff;
  -webkit-transition: .5s ease-in-out 0s;
  transition: .5s ease-in-out 0s;
}
/* line 84, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/devise.scss */
.actions:hover {
  background: #6877ff;
  color: #fff;
  font-weight: bold;
  border: none;
}
/* line 90, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/devise.scss */
.actions input {
  -webkit-transition: .5s ease-in-out 0s;
  transition: .5s ease-in-out 0s;
}
/* line 92, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/devise.scss */
.actions input:focus {
  background: #6877ff;
  color: #fff;
  font-weight: bold;
  border: none;
}
/* line 99, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/devise.scss */
.actions form {
  height: 100%;
}

/* line 2, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/staticpages.scss */
.home--ul {
  list-style: none;
  min-height: 100vh;
  background: #2e3c54;
}
/* line 6, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/staticpages.scss */
.home--ul .home--ul__li {
  width: 48%;
  height: 250px;
  float: left;
  background: #384863;
  margin: 1%;
  -webkit-transition: .5s ease-in-out 0s;
  transition: .5s ease-in-out 0s;
}
/* line 13, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/staticpages.scss */
.home--ul .home--ul__li:hover {
  background: #179DBA;
}
/* line 16, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/staticpages.scss */
.home--ul .home--ul__li a {
  text-decoration: none;
  display: block;
  height: 100%;
  text-align: center;
  padding: 110px 0;
  font-size: 17px;
  font-weight: bold;
  color: #fff;
}

/* line 1, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/users.scss */
.users, .window-index {
  background: #2e3c54;
  min-height: 100vh;
  color: #fff;
  padding: 10px 10px;
}
/* line 6, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/users.scss */
.users .flash_box, .window-index .flash_box {
  border-radius: 10px;
  color: #FFF;
  margin: 1rem 0;
  padding: 1rem;
}
/* line 11, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/users.scss */
.users .flash_box.is-success, .window-index .flash_box.is-success {
  border: 2px solid #58CF32;
  color: #58CF32;
}
/* line 15, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/users.scss */
.users .flash_box.is-error, .window-index .flash_box.is-error {
  border: 2px solid #e8384f;
  color: #e8384f;
}
/* line 20, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/users.scss */
.users h2, .window-index h2 {
  color: #fff;
}
/* line 23, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/users.scss */
.users table, .window-index table {
  width: 100%;
}
/* line 25, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/users.scss */
.users table tr, .window-index table tr {
  background: #2e3c54;
  text-align: left;
  border-bottom: solid 1px #374763;
}
/* line 30, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/users.scss */
.users table tr:hover, .window-index table tr:hover {
  background: #263144;
}
/* line 33, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/users.scss */
.users table tr th, .window-index table tr th {
  color: #a9a9a9;
}
/* line 36, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/users.scss */
.users table tr td, .window-index table tr td {
  color: #fff;
}
/* line 38, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/pages/users.scss */
.users table tr td a, .window-index table tr td a {
  text-decoration: none;
  color: #e8384f;
}

@font-face {
  font-family: 'bokutachi';
  src: url("/assets/bokutachi.otf");
}
@font-face {
  font-family: 'Boku2-Bold';
  src: url("/assets/Boku2-Bold.otf");
}
@font-face {
  font-family: 'FlopDesignFONT';
  src: url("/assets/FlopDesignFONT.otf");
}
@media print {
  /* line 47, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/style.scss */
  .no-print {
    display: none;
  }
}
/* line 53, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/style.scss */
tr:nth-child(odd) {
  background: #fbfbfb;
}

/* line 58, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/style.scss */
.table__tr {
  height: 25px;
  max-height: 25px;
  background: #fff;
}
/* line 63, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/style.scss */
.table__tr:hover {
  background: #2e3c54;
  color: #fff;
}

/* line 68, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/style.scss */
.table__tr__th,
.table__tr__td {
  height: 25px;
  font-size: 11px;
  border-right: solid 1px #eee;
  border-bottom: solid 1px #eee;
  font-weight: bold;
}
/* line 75, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/style.scss */
.table__tr__th div,
.table__tr__td div {
  height: 25px;
  min-width: 130px;
  overflow: hidden;
  padding: 0px 10px;
  line-height: 2.2;
}
/* line 82, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/style.scss */
.table__tr__th .id, .table__tr__th .contract_type,
.table__tr__td .id,
.table__tr__td .contract_type {
  width: 100px;
}
/* line 83, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/style.scss */
.table__tr__th .office,
.table__tr__td .office {
  width: 70px;
}
/* line 84, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/style.scss */
.table__tr__th .name, .table__tr__th .number,
.table__tr__td .name,
.table__tr__td .number {
  width: 100px;
}
/* line 85, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/style.scss */
.table__tr__th .number2,
.table__tr__td .number2 {
  width: 135px;
}
/* line 86, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/style.scss */
.table__tr__th .date, .table__tr__th .tel,
.table__tr__td .date,
.table__tr__td .tel {
  width: 125px !important;
}
/* line 87, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/style.scss */
.table__tr__th .address, .table__tr__th .payment_type,
.table__tr__td .address,
.table__tr__td .payment_type {
  width: 200px;
}
/* line 88, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/style.scss */
.table__tr__th .product,
.table__tr__td .product {
  width: 250px;
}
/* line 89, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/style.scss */
.table__tr__th .note,
.table__tr__td .note {
  width: 500px;
  text-align: left;
}

/* line 91, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/style.scss */
.table__tr__th {
  background: #e4e4e4;
  color: #444;
}

/* line 95, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/style.scss */
.table__tr__th-v {
  width: 30%;
  min-width: 140px;
  background: #e4e4e4;
  font-size: 11px;
  color: #444;
  font-weight: bold;
  text-align: right;
  padding-right: 10px;
  border-bottom: solid 1px #dcd9d9;
}

/* line 106, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/style.scss */
.table__tr__td {
  text-align: center;
}
/* line 108, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/style.scss */
.table__tr__td input, .table__tr__td select {
  text-align: center;
  width: 100%;
  height: 100%;
}
/* line 113, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/style.scss */
.table__tr__td div {
  height: 25px;
}

/* line 117, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/style.scss */
.table__tr__td-v {
  width: 70%;
  min-width: 210px;
  font-size: 11px;
  height: 25px;
  font-weight: bold;
  border-right: solid 1px #eee;
  border-bottom: solid 1px #eee;
}
/* line 125, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/style.scss */
.table__tr__td-v input, .table__tr__td-v select {
  padding-left: 10px;
  width: 100%;
  height: 100%;
}
/* line 130, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/style.scss */
.table__tr__td-v div {
  height: 100%;
}

/* line 134, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/style.scss */
.td-v-show {
  padding-left: 10px;
}

/* line 137, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/style.scss */
.dtp {
  position: relative;
  padding: 0 !important;
  overflow: visible !important;
  min-width: 80px !important;
}
/* line 142, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/style.scss */
.dtp .bootstrap-datetimepicker-widget {
  background: #fff;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  height: 260px;
  border: solid 1px #ddd;
  box-shadow: #999 5px 5px 5px;
}
/* line 151, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/style.scss */
.dtp .bootstrap-datetimepicker-widget ul {
  list-style: none;
}

/* line 156, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/style.scss */
.datepickerM_Trigger1, .datepickerM_Trigger2 {
  width: 13px;
  position: absolute;
  top: 0;
  right: 0;
  background: #e4e4e4;
  z-index: 1;
  cursor: pointer;
}
/* line 164, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/style.scss */
.datepickerM_Trigger1:hover > .fa-play, .datepickerM_Trigger2:hover > .fa-play {
  color: #fff;
}
/* line 167, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/style.scss */
.datepickerM_Trigger1 .fa-play, .datepickerM_Trigger2 .fa-play {
  color: #000;
  font-size: 20px;
  -webkit-transition: .5s ease-in-out 0s;
  transition: .5s ease-in-out 0s;
}
/* line 171, /Users/joe/repository/NEO/ledger_app/app/assets/stylesheets/style.scss */
.datepickerM_Trigger1 .fa-play:before, .datepickerM_Trigger2 .fa-play:before {
  font-size: 10px;
  position: absolute;
  top: 7px;
  left: 3px;
}
.index-box {
  height: calc(100vh - 370px);
  overflow: scroll;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// ContractsIndexLedger.vue?590a9a0e